// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../../../../usr/local/source/node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../../../usr/local/source/node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../../../../../../../../usr/local/source/node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("data:image/svg+xml,%3Csvg xmlns=%27http://www.w3.org/2000/svg%27 width=%2724%27 height=%2724%27 viewBox=%270 0 24 24%27%3E%3Cpath d=%27M15.41 16.59L10.83 12l4.58-4.59L14 6l-6 6 6 6 1.41-1.41z%27 fill=%27%23000%27 /%3E%3Cpath fill=%27none%27 d=%27M0 0h24v24H0V0z%27/%3E%3C/svg%3E", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_1___ = new URL("data:image/svg+xml,%3Csvg xmlns=%27http://www.w3.org/2000/svg%27 width=%2724%27 height=%2724%27 viewBox=%270 0 24 24%27%3E%3Cpath d=%27M8.59 16.59L13.17 12 8.59 7.41 10 6l6 6-6 6-1.41-1.41z%27 fill=%27%23000%27 /%3E%3Cpath fill=%27none%27 d=%27M0 0h24v24H0V0z%27/%3E%3C/svg%3E", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_2___ = new URL("data:image/svg+xml,%3Csvg xmlns=%27http://www.w3.org/2000/svg%27 width=%2716%27 height=%2716%27 viewBox=%270 0 24 24%27 fill=%27gray%27%3E%3Cpath d=%27M20 3h-1V1h-2v2H7V1H5v2H4c-1.1 0-2 .9-2 2v16c0 1.1.9 2 2 2h16c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2zm0 18H4V8h16v13z%27/%3E%3Cpath fill=%27none%27 d=%27M0 0h24v24H0z%27/%3E%3C/svg%3E", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_3___ = new URL("data:image/svg+xml,%0A%3Csvg xmlns=%27http://www.w3.org/2000/svg%27 viewBox=%270 0 24 24%27 fill=%27black%27 width=%2718px%27 height=%2718px%27%3E%3Cpath d=%27M0 0h24v24H0z%27 fill=%27none%27/%3E%3Cpath d=%27M12 3c-4.97 0-9 4.03-9 9s4.03 9 9 9c.83 0 1.5-.67 1.5-1.5 0-.39-.15-.74-.39-1.01-.23-.26-.38-.61-.38-.99 0-.83.67-1.5 1.5-1.5H16c2.76 0 5-2.24 5-5 0-4.42-4.03-8-9-8zm-5.5 9c-.83 0-1.5-.67-1.5-1.5S5.67 9 6.5 9 8 9.67 8 10.5 7.33 12 6.5 12zm3-4C8.67 8 8 7.33 8 6.5S8.67 5 9.5 5s1.5.67 1.5 1.5S10.33 8 9.5 8zm5 0c-.83 0-1.5-.67-1.5-1.5S13.67 5 14.5 5s1.5.67 1.5 1.5S15.33 8 14.5 8zm3 4c-.83 0-1.5-.67-1.5-1.5S16.67 9 17.5 9s1.5.67 1.5 1.5-.67 1.5-1.5 1.5z%27/%3E%3C/svg%3E", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_4___ = new URL("data:image/svg+xml,%3Csvg xmlns=%27http://www.w3.org/2000/svg%27 width=%2724%27 height=%2724%27 viewBox=%270 0 24 24%27%3E%3Cpath d=%27M0 0h24v24H0z%27 fill=%27none%27/%3E%3Cpath d=%27M9 16.17L4.83 12l-1.42 1.41L9 19 21 7l-1.41-1.41z%27 fill=%27white%27/%3E%3C/svg%3E", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_5___ = new URL("data:image/svg+xml,%0A%3Csvg xmlns=%27http://www.w3.org/2000/svg%27 viewBox=%270 0 24 24%27 fill=%27gray%27 width=%2724px%27 height=%2724px%27%3E%3Cpath d=%27M0 0h24v24H0z%27 fill=%27none%27/%3E%3Cpath d=%27M19 3H5c-1.11 0-2 .9-2 2v14c0 1.1.89 2 2 2h14c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2zm-2 10h-4v4h-2v-4H7v-2h4V7h2v4h4v2z%27/%3E%3C/svg%3E", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_6___ = new URL("data:image/svg+xml,%0A%3Csvg xmlns=%27http://www.w3.org/2000/svg%27 width=%2724%27 height=%2724%27 viewBox=%270 0 24 24%27%3E%3Cpath fill=%27none%27 d=%27M0 0h24v24H0V0z%27/%3E%3Cpath d=%27M7 10l5 5 5-5H7z%27 fill=%27gray%27/%3E%3C/svg%3E", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_7___ = new URL("data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSIyNCIgaGVpZ2h0PSIyNCIgdmlld0JveD0iMCAwIDI0IDI0Ij48cGF0aCBkPSJNMCAwaDI0djI0SDB6IiBmaWxsPSJub25lIiAvPjxwYXRoIGQ9Ik05IDE2LjE3TDQuODMgMTJsLTEuNDIgMS40MUw5IDE5IDIxIDdsLTEuNDEtMS40MXoiIGZpbGw9IndoaXRlIiAvPjwvc3ZnPgo=", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_8___ = new URL("data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSIyNCIgaGVpZ2h0PSIyNCIgdmlld0JveD0iMCAwIDI0IDI0Ij48cGF0aCBkPSJNMTUuNSAxNGgtLjc5bC0uMjgtLjI3QzE1LjQxIDEyLjU5IDE2IDExLjExIDE2IDkuNSAxNiA1LjkxIDEzLjA5IDMgOS41IDNTMyA1LjkxIDMgOS41IDUuOTEgMTYgOS41IDE2YzEuNjEgMCAzLjA5LS41OSA0LjIzLTEuNTdsLjI3LjI4di43OWw1IDQuOTlMMjAuNDkgMTlsLTQuOTktNXptLTYgMEM3LjAxIDE0IDUgMTEuOTkgNSA5LjVTNy4wMSA1IDkuNSA1IDE0IDcuMDEgMTQgOS41IDExLjk5IDE0IDkuNSAxNHoiIGZpbGw9IiNlNmU2ZTgiLz48cGF0aCBkPSJNMCAwaDI0djI0SDB6IiBmaWxsPSJub25lIi8+PC9zdmc+", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_9___ = new URL("data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSIyNCIgaGVpZ2h0PSIyNCIgdmlld0JveD0iMCAwIDI0IDI0Ij48cGF0aCBkPSJNNy40MSA4LjU5TDEyIDEzLjE3bDQuNTktNC41OEwxOCAxMGwtNiA2LTYtNiAxLjQxLTEuNDF6Ii8+PHBhdGggZmlsbD0ibm9uZSIgZD0iTTAgMGgyNHYyNEgwVjB6Ii8+PC9zdmc+", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_10___ = new URL("data:image/svg+xml;base64,CjxzdmcgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIiB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIHZpZXdCb3g9IjAgMCAyNCAyNCI+PHBhdGggZD0iTTcuNDEgMTUuNDFMMTIgMTAuODNsNC41OSA0LjU4TDE4IDE0bC02LTYtNiA2eiIvPjxwYXRoIGQ9Ik0wIDBoMjR2MjRIMHoiIGZpbGw9Im5vbmUiLz48L3N2Zz4=", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_11___ = new URL("data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSIyNCIgaGVpZ2h0PSIyNCIgdmlld0JveD0iMCAwIDI0IDI0Ij48cGF0aCBkPSJNMCAwaDI0djI0SDB6IiBmaWxsPSJub25lIi8+PHBhdGggZD0iTTkgMTYuMTdMNC44MyAxMmwtMS40MiAxLjQxTDkgMTkgMjEgN2wtMS40MS0xLjQxeiIgZmlsbD0iIzAwN2FmZiIvPjwvc3ZnPg==", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_12___ = new URL("data:image/svg+xml,%3Csvg version=%271.1%27 id=%27Layer_1%27 xmlns=%27http://www.w3.org/2000/svg%27 xmlns:xlink=%27http://www.w3.org/1999/xlink%27 x=%270px%27 y=%270px%27 viewBox=%270 0 512 512%27 style=%27enable-background:new 0 0 512 512;%27 xml:space=%27preserve%27%3E%3Cpath style=%27fill:%23C30B15;%27 d=%27M511.344,274.266C511.77,268.231,512,262.143,512,256C512,114.615,397.385,0,256,0S0,114.615,0,256 c0,117.769,79.53,216.949,187.809,246.801L511.344,274.266z%27/%3E%3Cpath style=%27fill:%2385080E;%27 d=%27M511.344,274.266L314.991,77.913L119.096,434.087l68.714,68.714C209.522,508.787,232.385,512,256,512 C391.243,512,501.976,407.125,511.344,274.266z%27/%3E%3Cpolygon style=%27fill:%23FFFFFF;%27 points=%27278.328,333.913 255.711,77.913 119.096,77.913 119.096,311.652 %27/%3E%3Cpolygon style=%27fill:%23E8E6E6;%27 points=%27392.904,311.652 392.904,155.826 337.252,133.565 314.991,77.913 255.711,77.913 256.067,333.913 %27/%3E%3Cpolygon style=%27fill:%23FFFFFF;%27 points=%27314.991,155.826 314.991,77.913 392.904,155.826 %27/%3E%3Crect x=%27119.096%27 y=%27311.652%27 style=%27fill:%23FC0F1A;%27 width=%27273.809%27 height=%27122.435%27/%3E%3Cg%3E%3Cpath style=%27fill:%23FFFFFF;%27 d=%27M204.871,346.387c13.547,0,21.341,6.659,21.341,18.465c0,12.412-7.795,19.601-21.341,19.601h-9.611 v14.909h-13.471v-52.975L204.871,346.387L204.871,346.387z M195.26,373.858h8.93c5.904,0,9.308-2.952,9.308-8.552 c0-5.525-3.406-8.324-9.308-8.324h-8.93V373.858z%27/%3E%3Cpath style=%27fill:%23FFFFFF;%27 d=%27M257.928,346.387c16.649,0,28.152,10.746,28.152,26.487c0,15.666-11.655,26.488-28.683,26.488 h-22.25v-52.975H257.928z M248.619,388.615h9.611c8.249,0,14.151-6.357,14.151-15.665c0-9.384-6.205-15.817-14.757-15.817h-9.006 V388.615z%27/%3E%3Cpath style=%27fill:%23FFFFFF;%27 d=%27M308.563,356.982v12.26h23.763v10.596h-23.763v19.525h-13.471v-52.975h39.277v10.595h-25.806 V356.982z%27/%3E%3C/g%3E%3C/svg%3E%0A", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_13___ = new URL("data:image/svg+xml,%3Csvg xmlns=%27http://www.w3.org/2000/svg%27 width=%2724%27 height=%2724%27 viewBox=%270 0 24 24%27%3E%3Cpath d=%27M19 6.41L17.59 5 12 10.59 6.41 5 5 6.41 10.59 12 5 17.59 6.41 19 12 13.41 17.59 19 19 17.59 13.41 12z%27/%3E%3Cpath d=%27M0 0h24v24H0z%27 fill=%27none%27/%3E%3C/svg%3E", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_14___ = new URL("data:image/svg+xml,%3Csvg xmlns=%27http://www.w3.org/2000/svg%27 width=%2720%27 height=%2720%27 viewBox=%270 0 24 24%27 fill=%27white%27%3E%3Cpath d=%27M19 6.41L17.59 5 12 10.59 6.41 5 5 6.41 10.59 12 5 17.59 6.41 19 12 13.41 17.59 19 19 17.59 13.41 12z%27/%3E%3Cpath d=%27M0 0h24v24H0z%27 fill=%27none%27/%3E%3C/svg%3E", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_15___ = new URL("data:image/svg+xml,%3Csvg xmlns=%27http://www.w3.org/2000/svg%27 width=%2720%27 height=%2720%27 viewBox=%270 0 24 24%27 fill=%27black%27%3E%3Cpath d=%27M19 6.41L17.59 5 12 10.59 6.41 5 5 6.41 10.59 12 5 17.59 6.41 19 12 13.41 17.59 19 19 17.59 13.41 12z%27/%3E%3Cpath d=%27M0 0h24v24H0z%27 fill=%27none%27/%3E%3C/svg%3E", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_16___ = new URL("data:image/svg+xml,%0A%3Csvg xmlns=%27http://www.w3.org/2000/svg%27 width=%2724%27 height=%2724%27 viewBox=%270 0 24 24%27%3E%3Cpath d=%27M22 9.24l-7.19-.62L12 2 9.19 8.63 2 9.24l5.46 4.73L5.82 21 12 17.27 18.18 21l-1.63-7.03L22 9.24zM12 15.4l-3.76 2.27 1-4.28-3.32-2.88 4.38-.38L12 6.1l1.71 4.04 4.38.38-3.32 2.88 1 4.28L12 15.4z%27 fill=%27gray%27/%3E%3Cpath d=%27M0 0h24v24H0z%27 fill=%27none%27/%3E%3C/svg%3E", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_17___ = new URL("data:image/svg+xml,%0A%3Csvg xmlns=%27http://www.w3.org/2000/svg%27 width=%2724%27 height=%2724%27 viewBox=%270 0 24 24%27 fill=%27black%27%3E%3Cpath d=%27M0 0h24v24H0z%27 fill=%27none%27/%3E%3Cpath d=%27M12 17.27L18.18 21l-1.64-7.03L22 9.24l-7.19-.61L12 2 9.19 8.63 2 9.24l5.46 4.73L5.82 21z%27/%3E%3Cpath d=%27M0 0h24v24H0z%27 fill=%27none%27/%3E%3C/svg%3E", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_18___ = new URL("data:image/svg+xml,%0A%3Csvg xmlns=%27http://www.w3.org/2000/svg%27 width=%2724%27 height=%2724%27 viewBox=%270 0 24 24%27 fill=%27red%27%3E%3Cpath d=%27M0 0h24v24H0z%27 fill=%27none%27/%3E%3Cpath d=%27M12 17.27L18.18 21l-1.64-7.03L22 9.24l-7.19-.61L12 2 9.19 8.63 2 9.24l5.46 4.73L5.82 21z%27/%3E%3Cpath d=%27M0 0h24v24H0z%27 fill=%27none%27/%3E%3C/svg%3E", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_19___ = new URL("data:image/svg+xml,%3Csvg xmlns=%27http://www.w3.org/2000/svg%27 width=%2724%27 height=%2724%27 viewBox=%270 0 24 24%27 fill=%27white%27%3E%3Cpath d=%27M19 6.41L17.59 5 12 10.59 6.41 5 5 6.41 10.59 12 5 17.59 6.41 19 12 13.41 17.59 19 19 17.59 13.41 12z%27/%3E%3Cpath d=%27M0 0h24v24H0z%27 fill=%27none%27/%3E%3C/svg%3E", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_20___ = new URL("data:image/svg+xml,%3Csvg xmlns=%27http://www.w3.org/2000/svg%27 viewBox=%270 0 24 24%27 fill=%27gray%27 width=%2718px%27 height=%2718px%27%3E%3Cpath d=%27M0 0h24v24H0z%27 fill=%27none%27/%3E%3Cpath d=%27M15.41 7.41L14 6l-6 6 6 6 1.41-1.41L10.83 12z%27/%3E%3C/svg%3E", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_21___ = new URL("data:image/svg+xml,%3Csvg xmlns=%27http://www.w3.org/2000/svg%27 viewBox=%270 0 24 24%27 fill=%27lightgray%27 width=%2718px%27 height=%2718px%27%3E%3Cpath d=%27M0 0h24v24H0z%27 fill=%27none%27/%3E%3Cpath d=%27M15.41 7.41L14 6l-6 6 6 6 1.41-1.41L10.83 12z%27/%3E%3C/svg%3E", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_22___ = new URL("data:image/svg+xml,%3Csvg xmlns=%27http://www.w3.org/2000/svg%27 viewBox=%270 0 24 24%27 fill=%27gray%27 width=%2718px%27 height=%2718px%27%3E%3Cpath d=%27M0 0h24v24H0z%27 fill=%27none%27/%3E%3Cpath d=%27M10 6L8.59 7.41 13.17 12l-4.58 4.59L10 18l6-6z%27/%3E%3C/svg%3E", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_23___ = new URL("data:image/svg+xml,%3Csvg xmlns=%27http://www.w3.org/2000/svg%27 viewBox=%270 0 24 24%27 fill=%27lightgray%27 width=%2718px%27 height=%2718px%27%3E%3Cpath d=%27M0 0h24v24H0z%27 fill=%27none%27/%3E%3Cpath d=%27M10 6L8.59 7.41 13.17 12l-4.58 4.59L10 18l6-6z%27/%3E%3C/svg%3E", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_24___ = new URL("data:image/svg+xml,%3Csvg xmlns=%27http://www.w3.org/2000/svg%27 height=%2724%27 viewBox=%270 0 24 24%27 width=%2724%27%3E%3Cpath d=%27M19 3H5c-1.11 0-2 .9-2 2v14c0 1.1.89 2 2 2h14c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2zm-2 10h-4v4h-2v-4H7v-2h4V7h2v4h4v2z%27 fill=%27%23bbbbbb%27/%3E%3Cpath d=%27M0 0h24v24H0z%27 fill=%27none%27/%3E%3C/svg%3E", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_25___ = new URL("data:image/svg+xml,%0A%3Csvg xmlns=%27http://www.w3.org/2000/svg%27 viewBox=%270 0 24 24%27 fill=%27black%27 width=%2718px%27 height=%2718px%27%3E%3Cpath d=%27M0 0h24v24H0z%27 fill=%27none%27/%3E%3Cpath d=%27M12 8c1.1 0 2-.9 2-2s-.9-2-2-2-2 .9-2 2 .9 2 2 2zm0 2c-1.1 0-2 .9-2 2s.9 2 2 2 2-.9 2-2-.9-2-2-2zm0 6c-1.1 0-2 .9-2 2s.9 2 2 2 2-.9 2-2-.9-2-2-2z%27/%3E%3C/svg%3E", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
var ___CSS_LOADER_URL_REPLACEMENT_1___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_1___);
var ___CSS_LOADER_URL_REPLACEMENT_2___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_2___);
var ___CSS_LOADER_URL_REPLACEMENT_3___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_3___);
var ___CSS_LOADER_URL_REPLACEMENT_4___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_4___);
var ___CSS_LOADER_URL_REPLACEMENT_5___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_5___);
var ___CSS_LOADER_URL_REPLACEMENT_6___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_6___);
var ___CSS_LOADER_URL_REPLACEMENT_7___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_7___);
var ___CSS_LOADER_URL_REPLACEMENT_8___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_8___);
var ___CSS_LOADER_URL_REPLACEMENT_9___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_9___);
var ___CSS_LOADER_URL_REPLACEMENT_10___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_10___);
var ___CSS_LOADER_URL_REPLACEMENT_11___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_11___);
var ___CSS_LOADER_URL_REPLACEMENT_12___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_12___);
var ___CSS_LOADER_URL_REPLACEMENT_13___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_13___);
var ___CSS_LOADER_URL_REPLACEMENT_14___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_14___);
var ___CSS_LOADER_URL_REPLACEMENT_15___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_15___);
var ___CSS_LOADER_URL_REPLACEMENT_16___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_16___);
var ___CSS_LOADER_URL_REPLACEMENT_17___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_17___);
var ___CSS_LOADER_URL_REPLACEMENT_18___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_18___);
var ___CSS_LOADER_URL_REPLACEMENT_19___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_19___);
var ___CSS_LOADER_URL_REPLACEMENT_20___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_20___);
var ___CSS_LOADER_URL_REPLACEMENT_21___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_21___);
var ___CSS_LOADER_URL_REPLACEMENT_22___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_22___);
var ___CSS_LOADER_URL_REPLACEMENT_23___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_23___);
var ___CSS_LOADER_URL_REPLACEMENT_24___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_24___);
var ___CSS_LOADER_URL_REPLACEMENT_25___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_25___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `
/**
 * (c) jSuites Javascript Web Components
 *
 * Website: https://jsuites.net
 * Description: Create amazing web based applications.
 *
 * MIT License
 *
 */

src/assets/lib/:root {
  --button-color: #298BA8;
  --active-color: #007aff;
  --safe-area-top: env(safe-area-inset-top);
  --safe-area-bottom: env(safe-area-inset-bottom);
}

div[data-before]:before {
  content: attr(data-before);
}

.unselectable {
  -webkit-touch-callout: none;
  -webkit-user-select: none;
  -khtml-user-select: none;
  -moz-user-select: none;
  -ms-user-select: none;
  user-select: none;
}

.jreadonly {
  pointer-events: none;
}

.jdragging {
  opacity:0.2;
  filter: alpha(opacity=20);
}

.jupload.input {
  position: relative;
  box-sizing: border-box;
  background-size: initial;
  height: 33px;
  min-height: initial;
  padding: 6px;
  padding-right: 30px;
}

.jupload.input:before {
  content: "save";
  font-size: 18px;
  font-family: "Material Icons";
  color: #000;
  position: absolute;
  right: 5px;
}

.jupload img {
  width: 100%;
}

.jupload.input img {
  width: initial;
  max-width: 100%;
  height: 100%;
}

.jupload[data-multiple] {
  padding: 10px;
}

.jupload[data-multiple] img {
  height: 70px;
  width: 100px;
  object-fit: cover;
  margin-right: 5px;
  margin-bottom: 5px;
}

.jupload {
  position: relative;
  border: 1px dotted #eee;
  cursor: pointer;
  box-sizing: border-box;
  width: 100%;
  max-height: 100%;
  min-height: 180px;
}

.jupload:not(.input):before {
  content: "\\e2c3";
  font-family: "Material Icons";
  font-size: 90px;
  color: #eee;
  width: 100%;
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  position: absolute;
  z-index: -1;
}

.jupload-item {
  padding-right: 22px;
  border-radius: 1px;
  display: inline-block;
  position: relative;
}

.jphoto {
  position: relative;
  border: 1px dotted #eee;
  cursor: pointer;
  box-sizing: border-box;
  width: 100%;
  max-height: 100%;
  min-height: 180px;
  display: flex;
  align-items: center;
  justify-content: center;
}

.jphoto:empty:before {
  content: "\\e2c3";
  font-family: "Material Icons";
  font-size: 90px;
  color: #eee;
  width: 100%;
  height: 100%;
}

.jremove {
  opacity: 0.2;
  filter: alpha(opacity=20);
}

.round img {
  border-radius: 1000px;
}



/** Animations **/
.fade-in {
  animation: fade-in 2s forwards;
}

.fade-out {
  animation: fade-out 1s forwards;
}

.slide-left-in {
  position: relative;
  animation: slide-left-in 0.4s forwards;
}

.slide-left-out {
  position: relative;
  animation: slide-left-out 0.4s forwards;
}

.slide-right-in {
  position: relative;
  animation: slide-right-in 0.4s forwards;
}

.slide-right-out {
  position: relative;
  animation: slide-right-out 0.4s forwards;
}

.slide-top-in {
  position: relative;
  animation: slide-top-in 0.4s forwards;
}

.slide-top-out {
  position: relative;
  animation: slide-top-out 0.2s forwards;
}

.slide-bottom-in {
  position: relative;
  animation: slide-bottom-in 0.4s forwards;
}

.slide-bottom-out {
  position: relative;
  animation: slide-bottom-out 0.1s forwards;
}

.spin {
  animation: spin 2s infinite linear;
}

/** Fadein and Fadeout **/
@keyframes fade-in {
  0% { opacity: 0; }
  100% { opacity: 100; }
}

@-webkit-keyframes fade-in {
  0% { opacity: 0; }
  100% { opacity: 100; }
}

@keyframes fade-out {
  0% { opacity: 100; }
  100% { opacity: 0; }
}

@-webkit-keyframes fade-out {
  0% { opacity: 100; }
  100% { opacity: 0; }
}

/** Keyframes Left to Right **/
@keyframes slide-left-in {
  0% { left: -100%; }
  100% { left: 0%; }
}

@-webkit-keyframes slide-left-in {
  0% { left: -100%; }
  100% { left: 0%; }
}

@keyframes slide-left-out {
  0% { left: 0%; }
  100% { left: -100%; }
}

@-webkit-keyframes slide-left-out {
  0% { left: 0%; }
  100% { left: -100%; }
}

/** Keyframes Right to Left **/
@keyframes slide-right-in {
  0% { left: 100%; }
  100% { left: 0%; }
}

@-webkit-keyframes slide-right-in
{
  0% { left: 100%; }
  100% { left: 0%; }
}

@keyframes slide-right-out {
  0% { left: 0%; }
  100% { left: 100%; }
}

@-webkit-keyframes slide-right-out {
  0% { left: 0%; }
  100% { left: 100%; }
}

/** Keyframes Top to Bottom **/
@keyframes slide-top-in {
  0% { transform: translateY(-100%); }
  100% { transform: translateY(0%); }
}

@-webkit-keyframes slide-top-in {
  0% { transform: translateY(-100%); }
  100% { -webkit-transform: translateY(0%); }
}

@keyframes slide-top-out {
  0% { transform: translateY(0%); }
  100% { transform: translateY(-100%); }
}

@-webkit-keyframes slide-top-out {
  0% { -webkit-transform: translateY(0%); }
  100% { -webkit-transform: translateY(-100%); }
}

/** Keyframes Bottom to Top **/
@keyframes slide-bottom-in {
  0% { transform: translateY(100%); }
  100% { transform: translateY(0%); }
}

@-webkit-keyframes slide-bottom-in {
  0% { transform: translateY(100%); }
  100% { -webkit-transform: translateY(0%); }
}

@keyframes slide-bottom-out {
  0% { transform: translateY(0%); }
  100% { transform: translateY(100%); }
}

@-webkit-keyframes slide-bottom-out {
  0% { -webkit-transform: translateY(0%); }
  100% { -webkit-transform: translateY(100%); }
}

@-webkit-keyframes spin {
  from {
      -webkit-transform:rotate(0deg);
  }
  to {
      -webkit-transform:rotate(359deg);
  }
}

@keyframes spin {
  from {
      transform:rotate(0deg);
  }
  to {
      transform:rotate(359deg);
  }
}

.jcalendar {
  position:absolute;
  z-index:9000;
  display:none;
  box-sizing:border-box;
  -webkit-touch-callout: none;
  -webkit-user-select: none;
  -khtml-user-select: none;
  -moz-user-select: none;
  -ms-user-select: none;
  user-select: none;
  -webkit-tap-highlight-color: rgba(0,0,0,0);
  -webkit-tap-highlight-color: transparent;
  min-width:280px;
}

.jcalendar.jcalendar-focus {
  display:block;
}

.jcalendar .jcalendar-backdrop {
  position:fixed;
  top:0px;
  left:0px;
  z-index:9000;
  min-width:100%;
  min-height:100%;
  background-color:rgba(0,0,0,0.5);
  border:0px;
  padding:0px;
  display:none;
}

.jcalendar .jcalendar-container {
  position:relative;
  box-sizing:border-box;
}

.jcalendar .jcalendar-content {
  position:absolute;
  z-index:9001;
  -webkit-box-shadow: 1px 1px 5px 0px rgba(0,0,0,0.39);
  -moz-box-shadow: 1px 1px 5px 0px rgba(0,0,0,0.39);
  box-shadow: 1px 1px 5px 0px rgba(0,0,0,0.39);
  background-color:#fff;
}

.jcalendar-header {
  text-align:center;
}

.jcalendar-header span {
  margin-right:4px;
  font-size:1.1em;
  font-weight:bold;
}

.jcalendar-prev {
  cursor:pointer;
  background-image:url(${___CSS_LOADER_URL_REPLACEMENT_0___});
  background-position:center;
  background-repeat:no-repeat;
}

.jcalendar-next {
  cursor:pointer;
  background-image:url(${___CSS_LOADER_URL_REPLACEMENT_1___});
  background-position:center;
  background-repeat:no-repeat;
}

.jcalendar-weekday {
  font-weight: 600;
  background-color: #fcfcfc;
  padding: 14px;
}

.jcalendar-table > table {
  width:100%;
  background-color:#fff;
}

.jcalendar-table > table > thead {
  cursor:pointer;
}

.jcalendar-table thead td {
  padding:10px;
  height:40px;
}

.jcalendar-table > table > tbody td {
  box-sizing:border-box;
  cursor:pointer;
  padding:9px;
  font-size:0.9em;
}


.jcalendar-table tfoot td {
  padding:10px;
}

.jcalendar-months td, .jcalendar-years td {
  height:24px;
}

.jcalendar-input {
  padding-right:18px;
  background-image:url(${___CSS_LOADER_URL_REPLACEMENT_2___});
  background-position:top 50% right 5px;
  background-repeat:no-repeat;
  box-sizing: border-box;
}

.jcalendar-done {
  -webkit-box-shadow: 1px 1px 5px 0px rgba(0,0,0,0.39);
  -moz-box-shadow: 1px 1px 5px 0px rgba(0,0,0,0.39);
  box-shadow: 1px 1px 5px 0px rgba(0,0,0,0.39);
  background-color:#fff;
}

.jcalendar-update {
  border:1px solid #ccc;
  background-color:#fff;
  border-radius:4px;
  padding:5px;
  width:100%;
}

.jcalendar-container select {
  width:55px;
  display:inline-block;
  border:0px;
  padding:4px;
  text-align:center;
  font-size:1.1em;
  user-select:none;
  margin-right:10px;
}

.jcalendar-container select:first-child {
  margin-right:2px;
}

.jcalendar-selected {
  background-color:#eee;
}

.jcalendar-reset, .jcalendar-confirm {
  text-transform:uppercase;
  cursor:pointer;
  color: var(--active-color);
}

.jcalendar-controls {
  padding:15px;

  -webkit-box-sizing: border-box;
  box-sizing: border-box;
  vertical-align:middle;

  display: -webkit-box;
  display: -moz-box;
  display: -ms-flexbox;
  display: -webkit-flex;
  display: flex;

  -webkit-flex-flow: row wrap;
  justify-content: space-between;
  align-items:center;
}

.jcalendar-controls div {
  font-weight:bold;
}

.jcalendar-fullsize  {
  position:fixed;
  width:100%;
  top:0px;
  left:0px;
}

.jcalendar-fullsize .jcalendar-content
{
  position:fixed;
  width:100%;
  left:0px;
  bottom:0px;
}

.jcalendar-focus.jcalendar-fullsize .jcalendar-backdrop {
  display:block;
}

.jcalendar-sunday {
  color: red;
}
.jcalendar-disabled {
  color: #ccc;
}

.jcalendar-time {
  display:flex;
}


.jcolor {
  display: none;
  outline: none;
}

.jcolor-input {
  padding-right:18px;
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_3___});
  background-position:top 50% right 5px;
  background-repeat:no-repeat;
  box-sizing: border-box;
}

.jcolor-content {
  position: absolute;
  z-index: 9000;
  user-select: none;
  -webkit-font-smoothing: antialiased;
  font-size: .875rem;
  letter-spacing: .2px;
  -webkit-border-radius: 4px;
  border-radius: 4px;
  -webkit-box-shadow: 0 8px 10px 1px rgba(0,0,0,0.14), 0 3px 14px 2px rgba(0,0,0,0.12), 0 5px 5px -3px rgba(0,0,0,0.2);
  box-shadow: 0 8px 10px 1px rgba(0,0,0,0.14), 0 3px 14px 2px rgba(0,0,0,0.12), 0 5px 5px -3px rgba(0,0,0,0.2);
  background-color:#fff;
  box-sizing: border-box;
  min-width: 260px;
}

.jcolor-controls {
  display: flex;
  padding: 10px;
  border-bottom: 1px solid #eee;
  margin-bottom: 5px;
}

.jcolor-controls div {
  flex: 1;
  font-size: 1em;
  color: var(--active-color);
  text-transform: uppercase;
  font-weight: bold;
  box-sizing: border-box;
}

.jcolor-content table {
  border-collapse: collapse;
  box-sizing: border-box;
}

.jcolor-focus {
  display:block;
}

.jcolor table {
  width:100%;
  height:100%;
  min-height: 160px;
}

.jcolor td {
  padding: 7px;
}

.jcolor-selected {
  background-repeat:no-repeat;
  background-size: 16px;
  background-position: center;
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_4___});
}

.jcolor-fullscreen {
  position: fixed;
  left: 0px;
  bottom: 0px;
  width:100%;
  max-height: 290px;
  border-radius: 0px;
  box-sizing: border-box;
}

.jcolor-fullscreen .jcolor-controls {
  padding: 15px;
  -webkit-box-shadow: 1px 0px 1px 0px rgba(0,0,0,0.39);
  -moz-box-shadow: 1px 0px 1px 0px rgba(0,0,0,0.39);
  box-shadow: 1px 0px 1px 0px rgba(0,0,0,0.39);
}

.jcolor-reset {
  text-align: left;
}

.jcolor-close {
  text-align: right;
}

.jcolor-backdrop {
  position: fixed;
  top: 0px;
  left: 0px;
  min-width: 100%;
  min-height: 100%;
  background-color: rgba(0,0,0,0.5);
  border: 0px;
  padding: 0px;
  z-index: 8000;
  display: none;

-webkit-touch-callout: none; /* iOS Safari */
  -webkit-user-select: none; /* Safari */
   -khtml-user-select: none; /* Konqueror HTML */
     -moz-user-select: none; /* Firefox */
      -ms-user-select: none; /* Internet Explorer/Edge */
          user-select: none; /* Non-prefixed version, currently
                                supported by Chrome and Opera */
}

.jcolor-content .jtabs-content {
  padding: 7px;
}

.jcolor-grid tr:first-child > td:first-child {
  border-top-left-radius: 3px;
}

.jcolor-grid tr:first-child > td:last-child {
  border-top-right-radius: 3px;
}

.jcolor-grid tr:last-child > td:first-child {
  border-bottom-left-radius: 3px;
}

.jcolor-grid tr:last-child > td:last-child {
  border-bottom-right-radius: 3px;
}

.jcolor-hsl {
  box-sizing: border-box;
}

.jcolor-hsl > div {
  height: 100%;
  position: relative;
}

.jcolor-hsl canvas {
  display: block;
  border-radius: 4px;
  -webkit-user-drag: none;
}

.jcolor-point {
  height: 5px;
  width: 5px;
  background-color: #000;
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  border-radius: 50%;
}

.jcolor-sliders {
  padding: 10px 20px 10px 10px;
}

.jcolor-sliders input {
  -webkit-appearance: none;

  height: 12px;
  width: 80%;

  background: #d3d3d3;
  opacity: 1;

  border-radius: 30px;
  outline: none;
}

.jcolor-sliders-input-subcontainer {
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.jcolor-sliders-input-container {
  margin-top: 4px;
  line-height: 0.8em;
  text-align: left;
}

.jcolor-sliders-input-container > label {
  font-size: 10px;
  text-transform: uppercase;
  color: #bbbbbd;
}

.jcolor-sliders-input-subcontainer > input {
  border: 0px;
  padding: 1px;
}

.jcolor-sliders-input-container input::-webkit-slider-thumb {
  -webkit-appearance: none;
  height: 12px;
  width: 12px;
  border-radius: 50%;
  background: #000;
  border: 2px solid #fff;
  cursor: pointer;
}

.jcolor-sliders-input-container input::-moz-range-thumb {
  -webkit-appearance: none;
  height: 12px;
  width: 12px;
  border-radius: 50%;
  background: #000;
  border: 2px solid #fff;
  cursor: pointer;
}

.jcolor-sliders-final-color {
  padding: 6px;
  user-select: all;
  margin-top: 10px;
  text-align: center;
}

.jcolor-sliders-final-color > div:nth-child(2) {
  width: 71px;
  text-transform: uppercase;
}

.jcolor .jtabs .jtabs-headers-container .jtabs-controls {
  display: none !important;
}

.jcolor .jtabs .jtabs-headers-container {
  display: flex !important;
  justify-content: center;
  padding: 4px;
}

.jcolor .jtabs-headers > div:not(.jtabs-border) {
  padding: 2px !important;
  padding-left: 15px !important;
  padding-right: 15px !important;
  font-size: 0.8em;
}

.jcontextmenu {
  position:fixed;
  z-index:10000;
  background:#fff;
  color: #555;
  font-size: 11px;
  -webkit-user-select: none;
  -moz-user-select: none;
  user-select: none;
  -webkit-box-shadow: 2px 2px 2px 0px rgba(143, 144, 145, 1);
  -moz-box-shadow: 2px 2px 2px 0px rgba(143, 144, 145, 1);
  box-shadow: 2px 2px 2px 0px rgba(143, 144, 145, 1);
  border: 1px solid #C6C6C6;
  padding: 0px;
  padding-top:4px;
  padding-bottom:4px;
  margin:0px;
  outline:none;
  display:none;
}

.jcontextmenu.jcontextmenu-focus {
  display:inline-block;
}

.jcontextmenu > div {
  box-sizing: border-box;
  display: flex;
  padding: 8px 8px 8px 32px;
  width: 250px;
  position: relative;
  cursor: default;
  font-size: 11px;
  font-family:sans-serif;
  text-align: left;
}

.jcontextmenu > div::before {
  content: attr(data-icon);
  font-family: 'Material Icons' !important;
  font-weight: normal;
  font-style: normal;
  font-size: 16px;
  line-height: 1;
  letter-spacing: normal;
  text-transform: none;
  display: inline-block;
  white-space: nowrap;
  word-wrap: normal;
  direction: ltr;
  -webkit-font-feature-settings: 'liga';
  -webkit-font-smoothing: antialiased;
  position: absolute;
  left: 9px;
}

.jcontextmenu > div.header {
  display: none;
}

.jcontextmenu > div a {
  color: #555;
  text-decoration: none;
  flex: 1;
}

.jcontextmenu > div span {
  margin-right:10px;
}

.jcontextmenu .jcontextmenu-disabled a {
  color: #ccc;
}

.jcontextmenu > div:hover {
  background: #ebebeb;
}

.jcontextmenu hr {
  border: 1px solid #e9e9e9;
  border-bottom: 0;
  margin-top:5px;
  margin-bottom:5px;
}

.jcontextmenu > hr:hover {
  background: transparent;
}

.jcontextmenu .jcontextmenu {
  top: 4px;
  left: 99%;
  opacity: 0;
  position: absolute;
}

.jcontextmenu > div:hover > .jcontextmenu {
  display: block;
  opacity: 1;
  -webkit-transform: translate(0, 0) scale(1);
  transform: translate(0, 0) scale(1);
  pointer-events: auto;
}

@media only screen and (max-width: 420px) {
  .jcontextmenu {
      top: initial !important;
      left: 0px !important;
      bottom: 0px !important;
      width: 100vw;
      height: 260px;
      overflow: scroll;
      animation: slide-bottom-in 0.4s forwards;
      padding-top: 0px;
  }
  .jcontextmenu div {
      width: 100%;
      text-align: center;
      border-bottom: 1px solid #ccc;
      padding: 15px;
  }
  .jcontextmenu > div.header {
      background-color: lightgray;
      padding: 5px;
      top: 0px;
      position: sticky;
      z-index: 2;
  }
  .jcontextmenu > div.header > a.title {
      text-align: left;
  }

  .jcontextmenu > div.header > a.close {
      text-align: right;
  }

  .jcontextmenu > div::before {
      content: attr(data-icon);
      font-family: 'Material Icons' !important;
      font-weight: normal;
      font-style: normal;
      font-size: 16px;
      line-height: 1;
      letter-spacing: normal;
      text-transform: none;
      display: inline-block;
      white-space: nowrap;
      word-wrap: normal;
      direction: ltr;
      -webkit-font-feature-settings: 'liga';
      -webkit-font-smoothing: antialiased;
      position: absolute;
      left: 9px;
  }
  .jcontextmenu a {
      font-size: 1.4em;
      text-transform: uppercase;
  }
  .jcontextmenu span {
      display: none;
  }
  .jcontextmenu span {
      display: none;
  }
  .jcontextmenu hr {
      display: none;
  }
}


.jdropdown {
  cursor:pointer;
  -webkit-touch-callout: none;
  -webkit-user-select: none;
  -khtml-user-select: none;
  -moz-user-select: none;
  -ms-user-select: none;
  user-select: none;
  box-sizing: border-box;
  background:#fff;
  -webkit-tap-highlight-color: transparent;
  display: inline-block;
}

.jdropdown-header::placeholder {
  color:#000;
}

.jdropdown-backdrop {
  position:fixed;
  top:0px;
  left:0px;
  min-width:100%;
  min-height:100%;
  background-color:rgba(0,0,0,0.5);
  border:0px;
  padding:0px;
  z-index:8000;
  display:none;
}

.jdropdown[disabled] {
  opacity: 0.5;
  pointer-events: none;
}

.jdropdown-focus {
  position:relative;
}

.jdropdown-focus .jdropdown-container {
  transform: translate3d(0,0,0);
}

.jdropdown-default.jdropdown-focus .jdropdown-header {
  outline:auto 5px -webkit-focus-ring-color;
}

.jdropdown-default.jdropdown-focus .jdropdown-header.jdropdown-add {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_5___});
}

.jdropdown-container-header
{
  padding:0px;
  margin:0px;
  position:relative;
}

.jdropdown-header
{
  width:100%;
  appearance: none;
  background-repeat: no-repeat;
  background-position:top 50% right 5px;
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_6___});
  text-overflow: ellipsis;
  cursor:pointer;
  box-sizing: border-box;
  -webkit-appearance: none;
  -moz-appearance: none;
  padding-right:30px !important;
}

.jdropdown-insert-button
{
  font-size: 1.4em;
  text-transform: uppercase;
  position:absolute;
  right: 30px;
  top: 4px;
  display:none;
}

.jdropdown-container
{
  min-width: inherit;
  transform: translate3d(-10000px,0,0);
  position:absolute;
  z-index:9001;
}

.jdropdown-close
{
  display:none;
  font-size:1em;
  color: var(--active-color);
  text-transform:uppercase;
  text-align:right;
  padding:15px;
  font-weight:bold;
}

.jdropdown-content
{
  min-width:inherit;
  margin:0px;
  box-sizing:border-box;
}

.jdropdown-content:empty
{
}

.jdropdown-item
{
  white-space: nowrap;
  text-align: left;
  text-overflow: ellipsis;
  overflow-x: hidden;
  color: #000;
  display: flex;
  align-items: center;
}

.jdropdown-description
{
  text-overflow: ellipsis;
  overflow: hidden;
  line-height: 1.5em;
}

.jdropdown-image
{
  margin-right:10px;
  width: 32px;
  height: 32px;
  border-radius:20px;
}

.jdropdown-image-small
{
  width:24px;
  height:24px;
}

.jdropdown-icon
{
  margin-right:10px;
  font-size: 30px;
  margin-left: -5px;
}

.jdropdown-icon-small
{
  font-size: 24px;
  margin-left: 0px;
}

.jdropdown-title
{
  font-size: 0.7em;
  text-overflow: ellipsis;
  overflow-x: hidden;
  display: block;
}

/** Default visual **/

.jdropdown-default .jdropdown-header
{
  border:1px solid #ccc;
  padding:5px;
  padding-left:10px;
  padding-right:16px;
}

.jdropdown-default .jdropdown-container
{
  background-color:#fff;
}

.jdropdown-default.jdropdown-focus.jdropdown-insert .jdropdown-header {
  padding-right:50px;
}

.jdropdown-default.jdropdown-focus.jdropdown-insert .jdropdown-insert-button {
  display:block;
}

.jdropdown-default .jdropdown-content
{
  min-width:inherit;
  border:1px solid #8fb1e3;
  margin:0px;
  background-color:#fff;
  box-sizing:border-box;
  min-height:10px;
  max-height:215px;
  overflow-y:auto;
}

.jdropdown-default .jdropdown-item
{
  padding:4px;
  padding-left:8px;
  padding-right:40px;
}

.jdropdown-default .jdropdown-item:hover
{
  background-color:#1f93ff;
  color:#fff;
}

.jdropdown-default .jdropdown-cursor
{
  background-color:#eee;
}

.jdropdown-default .jdropdown-selected
{
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_7___});
  background-repeat:no-repeat;
  background-position:top 50% right 5px;
  background-color:#1f93ff;
  color:#fff;
}

.jdropdown-default .jdropdown-group {
  margin-top:5px;
}

.jdropdown-default .jdropdown-group .jdropdown-item {
  padding-left:16px;
}

.jdropdown-default .jdropdown-group-name {
  padding-left: 8px;
  font-weight: bold;
  text-align: left;
}

.jdropdown-default .jdropdown-reset_ {
  content:'x';
  position:absolute;
  top:0;
  right:0;
  margin:5px;
  margin-right:10px;
  font-size:12px;
  width:12px;
  cursor:pointer;
  text-shadow: 0px 0px 5px #fff;
  display:none;
  line-height: 1.8em;
}

.jdropdown-default.jdropdown-focus .jdropdown-reset_ {
  display:block;
}

/** Default render for mobile **/

.jdropdown-picker.jdropdown-focus .jdropdown-backdrop {
  display:block;
}

.jdropdown-picker .jdropdown-header {
  outline: none;
}

.jdropdown-picker .jdropdown-container
{
  position:fixed;
  bottom:0px;
  left:0px;
  border-bottom:1px solid #e6e6e8;
  width:100%;
  background-color:#fff;
  box-sizing: border-box;
}

.jdropdown-picker .jdropdown-close
{
  -webkit-box-shadow: 0px -1px 5px 0px rgba(0,0,0,0.39);
  -moz-box-shadow: 0px -1px 5px 0px rgba(0,0,0,0.39);
  box-shadow: 0px -1px 5px 0px rgba(0,0,0,0.39);
  background-color:#fff;
  display:block;
}

.jdropdown-picker .jdropdown-content
{
  overflow-y:scroll;
  height:280px;
  background-color:#fafafa;
  border-top:1px solid #e6e6e8;
}

.jdropdown-picker .jdropdown-group-name
{
  font-size: 1em;
  text-transform: uppercase;
  padding-top:10px;
  padding-bottom:10px;
  display: block;
  border-bottom: 1px solid #e6e6e8;
  padding-left:20px;
  padding-right:20px;
  text-align:center;
  font-weight:bold;
}

.jdropdown-picker .jdropdown-item
{
  font-size: 1em;
  text-transform: uppercase;
  padding-top:10px;
  padding-bottom:10px;
  border-bottom: 1px solid #e6e6e8;
  padding-left:20px;
  padding-right:20px;
}

.jdropdown-picker .jdropdown-selected
{
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_7___});
  background-repeat:no-repeat;
  background-position:top 50% right 15px;
  background-color:#1f93ff;
  color:#fff;
}

.jdropdown-picker .jdropdown-cursor
{
  background-color:#1f93ff;
  color:#fff;
}

/** Default render for mobile searchbar **/

.jdropdown-searchbar.jdropdown-focus
{
  position:fixed;
  top:0px !important;
  left:0px !important;
  width:100% !important;
  height:100% !important;
  background-color:#fafafa;
  padding:0px;
  z-index:9001;
  overflow-y:scroll;
  will-change: scroll-position;
  -webkit-overflow-scrolling: touch;
}

.jdropdown-searchbar.jdropdown-focus .jdropdown-container-header
{
  position: fixed;
  top: 0px;
  left: 0px;
  z-index: 9002;
  padding:10px;
  background-color:#fff;
  box-shadow: 0 1px 2px rgba(0,0,0,.1);
  max-height: 24px;
  width: 100%;
}

.jdropdown-searchbar.jdropdown-focus .jdropdown-header
{
  border: 0px;
  background-repeat: no-repeat;
  background-position-x: 0%;
  background-position-y: 40%;
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_8___});
  padding-left: 30px !important;
  padding-right: 60px !important;
}

.jdropdown-searchbar.jdropdown-focus .jdropdown-close
{
  display:block;
}

.jdropdown-searchbar .jdropdown-header {
  outline: none;
}

.jdropdown-searchbar .jdropdown-container
{
  margin-top: 40px;
  width:100%;
}

.jdropdown-searchbar .jdropdown-close
{
  position:fixed;
  top:0px;
  right:0px;
}

.jdropdown-searchbar .jdropdown-content
{
  margin-top:10px;
}

.jdropdown-searchbar .jdropdown-group
{
  margin-top:10px;
  margin-bottom:15px;
  background-color:#fff;
}

.jdropdown-searchbar .jdropdown-group-name
{
  border-top: 1px solid #e6e6e8;
  border-bottom: 1px solid #e6e6e8;
  padding:10px;
  padding-left:12px;
  font-weight:bold;
}

.jdropdown-searchbar .jdropdown-group-arrow
{
  float:right;
  width:24px;
  height:24px;
  background-repeat:no-repeat;
}

.jdropdown-searchbar .jdropdown-group-arrow-down
{
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_9___});
}

.jdropdown-searchbar .jdropdown-group-arrow-up
{
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_10___});
}

.jdropdown-searchbar .jdropdown-item
{
  padding-top:10px;
  padding-bottom:10px;
  border-bottom: 1px solid #e6e6e8;
  padding-left:15px;
  padding-right:40px;
  background-color:#fff;
  font-size:0.9em;
}

.jdropdown-searchbar .jdropdown-description {
  text-overflow: ellipsis;
  overflow: hidden;
  max-width: calc(100% - 20px);
}

.jdropdown-searchbar .jdropdown-content > .jdropdown-item:first-child
{
  border-top: 1px solid #e6e6e8;
}

.jdropdown-searchbar .jdropdown-selected
{
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_11___});
  background-repeat:no-repeat;
  background-position:top 50% right 15px;
}

/** List render **/

.jdropdown-list
{
}

.jdropdown-list .jdropdown-container
{
  display:block;
}

.jdropdown-list .jdropdown-header
{
  display:none;
}

.jdropdown-list .jdropdown-group
{
  background-color:#fff;
}

.jdropdown-list .jdropdown-group-name
{
  border-bottom: 1px solid #e6e6e8;
  padding-top:10px;
  padding-bottom:10px;
  font-weight:bold;
}

.jdropdown-list .jdropdown-item
{
  padding-top:10px;
  padding-bottom:10px;
  border-bottom: 1px solid #e6e6e8;
  padding-left:10px;
  padding-right:40px;
  background-color:#fff;
}

.jdropdown-list .jdropdown-selected
{
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_11___});
  background-repeat:no-repeat;
  background-position:top 50% right 10px;
}

@media only screen and (max-width : 800px)
{
  .jdropdown-list {
      width:100% !important;
      border:0px;
      padding:0px;
  }

  .jdropdown-list .jdropdown-container {
      min-width:100%;
  }

  .jdropdown-searchbar.jdropdown-focus .jdropdown-description {
      text-transform: uppercase;
  }
}

.app .jdropdown-item {
  text-transform:uppercase;
}

.jdropdown-create-container {
  margin: 10px;
  border: 1px solid #ccc;
  border-radius: 2px;
  padding: 6px;
}

.jdropdown-color {
  background-color: #fff;
  border: 1px solid transparent;
  border-radius: 12px;
  width: 12px;
  height: 12px;
  margin-right: 6px;
}

.jdropdown-item[data-disabled] {
  opacity: 0.5;
  pointer-events: none;
}

.jeditor-container {
  border:1px solid #ccc;
  box-sizing: border-box;
}

.jeditor-dragging {
   border:1px dashed #000;
}

.jeditor-container.jeditor-padding {
  padding:10px;
}

.jeditor {
  outline:none;
  word-break: break-word;

}

.jeditor[data-placeholder]:empty:before {
  content: attr(data-placeholder);
  color: lightgray;
}

.jeditor-container.jeditor-padding .jeditor {
  min-height:100px;
  margin-bottom:10px;
  padding:10px;
}

/** Snippet **/

.jsnippet {
  margin-top:15px;
  cursor:pointer;
  border: 1px solid #ccc;
  position:relative;
}

.jsnippet:focus {
  outline: none;
}

.jsnippet img {
  width:100%;
}

.jsnippet .jsnippet-title {
  padding:15px;
  font-size:1.4em;
}

.jsnippet .jsnippet-description {
  padding-left:15px;
  padding-right:15px;
  font-size:1em;
}

.jsnippet .jsnippet-host {
  padding:15px;
  text-transform:uppercase;
  font-size:0.8em;
  color:#777;
  text-align:right;
}

.jsnippet .jsnippet-url {
  display:none;
}

.jeditor .jsnippet:after {
  content: 'close';
  font-family: 'Material icons';
  font-size: 24px;
  width: 24px;
  height: 24px;
  line-height: 24px;
  cursor: pointer;
  text-shadow: 0px 0px 2px #fff;
  position: absolute;
  top: 12px;
  right: 12px;
}

.jsnippet * {
  -webkit-user-select: none;
  -khtml-user-select: none;
  -moz-user-select: none;
  -o-user-select: none;
  user-select: none;

  -webkit-user-drag: none;
  -khtml-user-drag: none;
  -moz-user-drag: none;
  -o-user-drag: none;
}

.jeditor img {
  border:2px solid transparent;
  box-sizing: border-box;
}

.jeditor img.resizing {
  -webkit-user-select: none;
  -khtml-user-select: none;
  -moz-user-select: none;
  -o-user-select: none;
  user-select: none;

  -webkit-user-drag: none;
  -khtml-user-drag: none;
  -moz-user-drag: none;
  -o-user-drag: none;
}

.jeditor img:focus {
  border:2px solid #0096FD;
  outline: #0096FD;
}

.jeditor .pdf {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_12___});
  background-repeat: no-repeat;
  background-size: cover;
  width:60px;
  height:60px;
}

.jeditor-toolbar {
  width: fit-content;
  max-width: 100%;
  box-sizing: border-box;
}

.jloading {
  position:fixed;
  z-index:10001;
  width:100%;
  left:0;
  right:0;
  top:0;
  bottom:0;
  background-color: rgba(0,0,0,0.7);
}

.jloading::after {
  content:'';
  display:block;
  margin:0 auto;
  margin-top:50vh;
  width:40px;
  height:40px;
  border-style:solid;
  border-color:white;
  border-top-color:transparent;
  border-width:4px;
  border-radius:50%;
  -webkit-animation: spin .8s linear infinite;
  animation: spin .8s linear infinite;
}

.jloading.spin {
  background-color:transparent;
}

.jloading.spin::after {
  margin:0 auto;
  margin-top:80px;
  border-color:#aaa;
  border-top-color:transparent;
}


.jmodal {
  position:fixed;
  top:50%;
  left:50%;
  width:60%;
  height:60%;
  -webkit-box-shadow: 0 2px 10px rgba(0,0,0,.2);
  -moz-box-shadow: 0 2px 10px rgba(0,0,0,.2);
  border:1px solid #ccc;
  background-color:#fff;
  transform: translate(-50%, -50%);
  box-sizing: border-box;
  padding-top:50px !important;
  z-index:9002;
  border-radius: 8px;
}

.jmodal:before {
  position:absolute;
  top:0;
  left:0;
  width:100%;
  content:attr(title);
  padding:15px;
  box-sizing: border-box;
  font-size:1.2em;
  box-shadow: 1px 1px 3px rgba(0,0,0,.2);
  background-color: #fff;
  border-radius: 8px 8px 0px 0px;
}

.jmodal_content {
  padding:20px;
  overflow-y:auto;
  max-height:100%;
  box-sizing: border-box;
  height: -webkit-fill-available;
}
.jmodal.no-title {
  padding-top: initial !important;
}

.jmodal.no-title:before {
  display:none;
}

.jmodal:after {
  content:'';
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_13___});
  position:absolute;
  top:0;
  right:0;
  margin:14px;
  font-size:24px;
  width:24px;
  height:24px;
  cursor:pointer;
  text-shadow: 0px 0px 5px #fff;
}

.jmodal_fullscreen {
  width: 100% !important;
  height: 100% !important;
  top: 0px;
  left: 0px;
  transform: none;
  border: 0px;
  border-radius: 0px;
}

.jmodal_backdrop {
  position: fixed;
  top: 0px;
  left: 0px;
  min-width: 100%;
  min-height: 100%;
  background-color: rgba(0,0,0,0.5);
  border: 0px;
  padding: 0px;
  z-index: 8000;
  display: none;

-webkit-touch-callout: none; /* iOS Safari */
  -webkit-user-select: none; /* Safari */
   -khtml-user-select: none; /* Konqueror HTML */
     -moz-user-select: none; /* Firefox */
      -ms-user-select: none; /* Internet Explorer/Edge */
          user-select: none; /* Non-prefixed version, currently
                                supported by Chrome and Opera */
}


.jnotification {
  position: fixed;
  z-index: 10000;
  -webkit-box-sizing: border-box;
  box-sizing: border-box;
  padding: 10px;
  bottom: 0px;
}

.jnotification-container {
  -webkit-box-shadow: 0px 2px 15px -5px rgba(0, 0, 0, 0.7);
  box-shadow: 0px 2px 15px -5px rgba(0, 0, 0, 0.7);
  padding: 12px;
  border-radius: 8px;

  background-color: #000;
  background: rgba(92,92,92,1);
  background: linear-gradient(0deg, rgba(92,92,92,1) 0%, rgba(77,77,77,1) 100%);
  color: #fff;
  width: 320px;
  margin: 30px;
  padding: 20px;
}

.jnotification-close {
  content: '';
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_14___});
  font-size: 20px;
  width: 20px;
  height: 20px;
  cursor: pointer;
}

.jnotification-title {
  font-weight: bold;
}

.jnotification-header {
  display: flex;
  padding-bottom: 5px;
}

.jnotification-header:empty {
  display: none;
}

.jnotification-image {
  margin-right: 5px;
}

.jnotification-image:empty {
  display: none;
}

.jnotification-image img {
  width: 24px;
}

.jnotification-name {
  text-transform: uppercase;
  font-size: 0.9em;
  flex: 1;
  letter-spacing: 0.1em;
}

.jnotification-error .jnotification-container {
  background: rgb(182,38,6);
  background: linear-gradient(0deg, rgba(170,41,13,1) 0%, rgba(149,11,11,1) 100%);
}

@media (max-width: 800px) {
  .jnotification {
      top: calc(0px + var(--safe-area-top));
      width: 100%;
  }
  .jnotification-container {
      background: rgba(255,255,255,0.95);
      border: 1px solid #eee;
      color: #444;
      margin: 0px;
      width: initial;
  }
  .jnotification-error .jnotification-container {
      background: rgba(255,255,255,0.95);
      color: #790909;
  }
  .jnotification-close {
      background-image: url(${___CSS_LOADER_URL_REPLACEMENT_15___});
  }
}

.jnotification-header {
  display: -webkit-box;
  display: -webkit-flex;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-pack: start;
  -webkit-justify-content: flex-start;
  -ms-flex-pack: start;
  justify-content: flex-start;
  -webkit-box-align: center;
  -webkit-align-items: center;
  -ms-flex-align: center;
  align-items: center;
}

.jpicker {
  cursor: pointer;
  white-space: nowrap;
  display: inline-flex;
  -webkit-user-select: none;
  -moz-user-select: none;
  -ms-user-select: none;
  user-select: none;
  outline: none;
  position: relative;
}

.jpicker-header {
  background-repeat: no-repeat;
  background-position: top 50% right 5px;
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_6___});
  text-overflow: ellipsis;
  cursor: pointer;
  box-sizing: border-box;
  text-align: left;
  outline: none;

  line-height: 24px;
  padding: 2px;
  padding-left: 12px;
  padding-right: 35px;
  outline: none;
  border-radius: 4px;
}

.jpicker-header:hover {
  background-color: #eee;
}

.jpicker-content {
  position: absolute;
  top: 0;
  display: none;
  box-shadow: 0 4px 5px 0 rgba(0,0,0,0.14), 0 1px 10px 0 rgba(0,0,0,0.12), 0 2px 4px -1px rgba(0,0,0,0.2);
  border-radius: 4px;
  background-color: #fff;
  padding: 4px;
  z-index: 50;
  text-align: left;
  max-height: 200px;
  scrollbar-width: thin;
  scrollbar-color: #333 transparent;
}

.jpicker-content::-webkit-scrollbar {
  width: 8px;
}

.jpicker-content::-webkit-scrollbar-track {
  background: #eee;
}

.jpicker-content::-webkit-scrollbar-thumb {
  background: #888;
}

.jpicker-content > div {
  padding: 6px;
  padding-left: 15px;
  padding-right: 15px;
}

.jpicker-focus > .jpicker-content {
  display: block;
}

.jpicker-content > div:hover {
  background-color:#efefef;
}

.jpicker-content > div:empty {
  opacity: 0;
}

.jpicker-header > i, .jpicker-header > div {
  display: block;
}

.jpicker-focus > .jpicker-content.jpicker-columns {
  display: flex !important ;
  justify-content: center;
  flex-wrap: wrap;
}



.jprogressbar
{
  cursor:pointer;
  -webkit-touch-callout: none;
  -webkit-user-select: none;
  -khtml-user-select: none;
  -moz-user-select: none;
  -ms-user-select: none;
  user-select: none;
  box-sizing: border-box;
  background:#fff;
  -webkit-tap-highlight-color: transparent;
  display: inline-block;
  box-sizing: border-box;
  cursor:pointer;
  border:1px solid #ccc;
  position:relative;
}

.jprogressbar::before {
  content:attr(data-value);
  position:absolute;
  margin:5px;
  margin-left:10px;
}

.jprogressbar-header::placeholder
{
  color:#000;
}

.jprogressbar::focus {
  outline: auto 5px -webkit-focus-ring-color;
}

.jprogressbar > div {
  background-color: #eee;
  background-color: red;
  box-sizing: border-box;
  height:31px;
}

.jrating {
  display:flex;
}
.jrating > div {
  width:24px;
  height:24px;
  line-height:24px;
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_16___});
}

.jrating .jrating-over {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_17___});
  opacity: 0.7;
}

.jrating .jrating-selected {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_18___});
}


.jsearch {
  position: relative;
  display: none;
  -webkit-user-select: none;
  -moz-user-select: none;
  -ms-user-select: none;
  user-select: none;
}

.jsearch_container {
  position: absolute;
  box-shadow: 0 1px 2px 0 rgba(60,64,67,0.302), 0 2px 6px 2px rgba(60,64,67,0.149);
  border: none;
  -webkit-border-radius: 4px;
  border-radius: 4px;
  width: 280px;
  padding: 8px 0;

  -webkit-box-shadow: 0 2px 4px rgba(0,0,0,0.2);
  box-shadow: 0 2px 4px rgba(0,0,0,0.2);
  -webkit-transition: opacity .218s;
  transition: opacity .218s;
  background: #fff;
  border: 1px solid rgba(0,0,0,.2);
  cursor: pointer;
  margin: 0;
  min-width: 300px;
  outline: none;
  width: auto;
  -webkit-user-select: none;
  -moz-user-select: none;
  -ms-user-select: none;
  user-select: none;
}

.jsearch_container:empty:after {
  content: attr(data-placeholder);
}

.jsearch_container > div {
  color: #333;
  cursor: pointer;
  display: -webkit-box;
  display: -webkit-flex;
  display: flex;
  padding: 5px 10px;
  user-select: none;
  -webkit-align-items: center;
  align-items: center;

  -webkit-user-select: none;
  -moz-user-select: none;
  -ms-user-select: none;
  user-select: none;
}

.jsearch_container > div:hover {
  background-color: #e8eaed;
}

.jsearch_container > div > img {
  width: 32px;
  height: 32px;
  user-select: none;
  border-radius: 16px;
  margin-right: 2px;
}

.jsearch_container > div > div {
  overflow: hidden;
  text-overflow: ellipsis;
  margin-left: 2px;
  max-width: 300px;
  white-space: nowrap;
  user-select: none;
}

.jsearch_container .selected {
  background-color: #e8eaed;
}

.jslider {
  outline: none;
}

.jslider-focus {
  width: 100% !important;
  height: 100% !important;
}

.jslider-focus img {
  display: none;
}

.jslider img {
  width: 100px;
}

.jslider-left::before {
  position: fixed;
  left: 15px;
  top: 50%;
  content:'arrow_back_ios';
  color: #fff;
  width: 30px;
  height: 30px;
  font-family: 'Material Icons';
  font-size: 30px;
  /* before it was 0px 0px 0px #000 */
  text-shadow: 0px 0px 6px rgb(56,56,56);
  text-align: center;
  cursor: pointer;
}

.jslider-right::after {
  position: fixed;
  right: 15px;
  top: 50%;
  content: 'arrow_forward_ios';
  color: #fff;
  width: 30px;
  height: 30px;
  font-family: 'Material Icons';
  font-size: 30px;
  /* before it was 0px 0px 0px #000 */
  text-shadow: 0px 0px 6px rgb(56,56,56);
  text-align: center;
  cursor: pointer;
}

.jslider-close {
  width:24px;
  height:24px;
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_19___});
  position:fixed;
  top:15px;
  right:15px;
  cursor:pointer;
  z-index:3000;

  display: block !important;
}

.jslider-counter {
  height:24px;
  background-color: transparent;
  position:fixed;
  left: 50%;
  transform: translateX(-50%);
  bottom: 15px;
  cursor:pointer;
  z-index:3000;

  display: flex;
  display: -webkit-flex;
  -webkit-justify-content: center;
  -webkit-align-items: center;
  -webkit-flex-direction: row;
  justify-content: center;
  align-items: center;
  flex-direction: row;
}

.jslider-caption {
  position: fixed;
  max-width: 90vw;
  text-overflow: ellipsis;
  white-space: nowrap;
  overflow: hidden;
  top:15px;
  left: 15px;
  z-index:3000;
  color: #FFF;
  font-size: 1rem;

  display: block !important;
}

.jslider-counter div {
  width: 10px;
  height: 10px;
  background: #fff;
  border-radius: 50%;
  margin: 0px 5px;

  display: block !important;
}

.jslider-counter .jslider-counter-focus {
  background-color: cornflowerblue;
  pointer-events: none;
}

.jslider-focus {
  position:fixed;
  left:0;
  top:0;
  width: 100%;
  min-height:100%;
  max-height:100%;
  z-index:2000;
  margin:0px;
  box-sizing:border-box;

  background-color:rgba(0,0,0,0.8);
  -webkit-transition-duration: .05s;
  transition-duration: .05s;
  display: flex;
  -ms-flex-align: center;
  -webkit-align-items: center;
  -webkit-box-align: center;

  align-items: center;
}

.jslider-focus img {
  width: 50vw;
  height: auto;
  box-sizing: border-box;
  margin:0 auto;
  vertical-align:middle;
  display:none;
}

.jslider-focus img.jslider-vertical {
  width: auto;
  /* before it was 50vh */
  height: 80vh;
}

@media only screen and (max-width: 576px) {
  .jslider-focus img.jslider-vertical {
      width: 99vw !important;
      height: auto !important;
  }

  .jslider-focus img {
      width: 100vw !important;
      height: auto !important;
  }
}

.jslider-grid {
  display: -ms-grid;
  display: grid;
  grid-gap: 1px;
  position: relative;
}

.jslider-grid[data-number='2'] {
  -ms-grid-columns: 1fr 50%;
  grid-template-columns: 1fr 50%;
}

.jslider-grid[data-number='3'] {
  -ms-grid-columns: 1fr 33%;
  grid-template-columns: 1fr 33%;
}

.jslider-grid[data-number='4'] {
  -ms-grid-columns: 1fr 25%;
  grid-template-columns: 1fr 25%;
}

.jslider-grid img {
  display: none;
  width: 100%;
  height: 100%;
  object-fit: cover;
}

.jslider-grid[data-total]:after {
  content: attr(data-total) "+";
  font-size: 1.5em;
  position:absolute;
  color: #fff;
  right: 15px;
  bottom: 6px;
}

.jslider-grid img:first-child {
  -ms-grid-column: 1;
  -ms-grid-row: 1;
  grid-column: 1;
  grid-row: 1;
  display: block;
}

.jslider-grid[data-number='2'] img:nth-child(2) {
  -ms-grid-column: 2;
  -ms-grid-row: 1;
  grid-column: 2;
  grid-row: 1;
  display: block;
}

.jslider-grid[data-number='3'] img:first-child {
  -ms-grid-column: 1 / 2;
  -ms-grid-row: 1 / 4;
  grid-column: 1 / 2;
  grid-row: 1 / 4;
}

.jslider-grid[data-number='3'] img:nth-child(2) {
  -ms-grid-column: 2;
  -ms-grid-row: 1;
  grid-column: 2;
  grid-row: 1;
  display: block;
}

.jslider-grid[data-number='3'] img:nth-child(3) {
  -ms-grid-column: 2;
  -ms-grid-row: 2;
  grid-column: 2;
  grid-row: 2;
  display: block;
}

.jslider-grid[data-number='4'] img:first-child {
  -ms-grid-column: 1 / 2;
  -ms-grid-row: 1 / 4;
  grid-column: 1 / 2;
  grid-row: 1 / 4;
}

.jslider-grid[data-number='4'] img:nth-child(2) {
  -ms-grid-column: 2;
  -ms-grid-row: 1;
  grid-column: 2;
  grid-row: 1;
  display: block;
}

.jslider-grid[data-number='4'] img:nth-child(3) {
  -ms-grid-column: 2;
  -ms-grid-row: 2;
  grid-column: 2;
  grid-row: 2;
  display: block;
}

.jslider-grid[data-number='4'] img:nth-child(4) {
  -ms-grid-column: 2;
  -ms-grid-row: 3;
  grid-column: 2;
  grid-row: 3;
  display: block;
}


.jtabs {
  max-width: 100vw;
  position: relative;
}

.jtabs .jtabs-headers-container {
  display: flex;
  align-items: center;
}

.jtabs .jtabs-headers {
  display: flex;
  align-items: center;
  overflow: hidden;
  position: relative;
}


.jtabs {
  max-width: 100vw;
  position: relative;
}

.jtabs .jtabs-headers-container {
  display: flex;
  align-items: center;
}

.jtabs .jtabs-headers {
  display: flex;
  align-items: center;
  overflow: hidden;
  position: relative;
}

.jtabs .jtabs-headers > div:not(.jtabs-border) {
  padding: 6px;
  padding-left: 20px;
  padding-right: 20px;
  margin-left: 1px;
  margin-right: 1px;
  background-color: #f1f1f1;
  cursor: pointer;
  white-space: nowrap;
  text-align: center;
}

.jtabs .jtabs-headers > div.jtabs-selected {
  background-color: #e8e8e8;
  color: #000;
}

.jtabs .jtabs-headers > div > div {
  color: #555;
  width: 100%;
  overflow: hidden;
}

.jtabs .jtabs-headers i {
  display: block;
  margin: auto;
}

.jtabs .jtabs-content {
  box-sizing: border-box;
}

.jtabs .jtabs-content > div {
  display: none;
  box-sizing: border-box;
}

.jtabs .jtabs-content > div.jtabs-selected {
  display: block;
}

.jtabs .jtabs-border {
  position: absolute;
  height: 2px;
  background-color: #888;
  transform-origin: left;
  transition: all .2s cubic-bezier(0.4,0,0.2,1);
  transition-property: color,left,transform;
  display: none;
}

.jtabs-animation .jtabs-border {
  display: initial;
}

.jtabs .jtabs-controls {
  margin: 3px;
  margin-left: 10px;
  display: flex;
  min-width: 82px;
}

.jtabs .jtabs-controls > div {
  cursor: pointer;
  background-position: center;
  background-repeat: no-repeat;
  width: 24px;
  height: 24px;
  line-height: 24px;
}

.jtabs .jtabs-prev {
  margin-left: 10px;
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_20___});
}

.jtabs .jtabs-prev.disabled {
  margin-left: 10px;
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_21___});
}

.jtabs .jtabs-next {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_22___});
}

.jtabs .jtabs-next.disabled {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_23___});
}

.jtabs .jtabs-add {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_24___});
}

/** Modern skin **/

.jtabs.jtabs-modern .jtabs-headers > div:not(.jtabs-border) {
  padding: 4px;
  padding-left: 10px;
  padding-right: 10px;
  background-color: #fff;
}

.jtabs.jtabs-modern .jtabs-headers > .jtabs-selected  {
  color: #000;
}

.jtabs.jtabs-modern .jtabs-headers > .jtabs-selected .material-icons {
  color: #000;
}

.jtabs.jtabs-modern .jtabs-headers {
  background: #EEEEEF !important;
  padding: 2px;
  border-radius: 4px;
}

.jtabs.jtabs-modern .jtabs-headers .jtabs-border {
  border-color: #EEEEEF !important;
}

.jtabs.jtabs-modern .jtabs-border {
  background-color: rgba(194, 197, 188, 0.884);
}

.jtags {
  display: flex;
  flex-wrap: wrap;
  -ms-flex-direction: row;
  -webkit-flex-direction: row;
  flex-direction: row;
  -ms-flex-pack: flex-start;
  -webkit-justify-content: space-between;
  justify-content: flex-start;
  padding: 2px;
  border: 1px solid #ccc;
}

.jtags.jtags-empty:not(.jtags-focus)::before {
  position: absolute;
  margin: 5px;
  color: #ccc;
  content:attr(data-placeholder);
}

.jtags > div {
  padding: 3px;
  padding-left: 10px;
  padding-right: 22px;
  position: relative;
  border-radius: 1px;
  margin: 2px;
  display: block;
  outline: none;
}

.jtags > div:empty:before {
  content: " ";
  white-space: pre;
}

.jtags > div::after {
  content: 'x';
  position: absolute;
  top: 4px;
  right: 4px;
  width: 12px;
  height: 12px;
  cursor: pointer;
  font-size: 11px;
  display: none;
}

.jtags_label {
  background-color: #eeeeee !important;
}

.jtags_label::after {
  display: inline-block !important;
}

.jtags_error::after {
  color: #fff  !important;
}

.jtags_error {
  background-color: #d93025 !important;
  color: #fff;
}


.jtoolbar-container {
  border-radius: 2px;
  margin-bottom: 5px;
  box-shadow: 0 4px 5px 0 rgba(0,0,0,0.14), 0 1px 10px 0 rgba(0,0,0,0.12), 0 2px 4px -1px rgba(0,0,0,0.2);
  display: inline-flex !important;
}

.jtoolbar {
  cursor: pointer;
  white-space: nowrap;
  display: flex;
  padding:4px;
  -webkit-user-select: none;
  -moz-user-select: none;
  -ms-user-select: none;
  user-select: none;
  font-size: 13px;
}

.jtoolbar-mobile {
  display: flex;
  position:fixed;
  bottom: 0;
  margin: 0;
  left: 0;
  width: 100%;
  background: #f7f7f8;
  z-index: 1;
  box-sizing: border-box;
  box-shadow: 0 -1px 2px rgba(0,0,0,.1);
  border-radius: 0px;
}

.jtoolbar > div {
  display: inline-flex;
  align-items: center;
  box-sizing: border-box;
  vertical-align:middle;
  justify-content: space-evenly;
}

.jtoolbar-mobile > div {
  display: flex;
  width: 100%;
}

.jtoolbar .jtoolbar-item {
  text-align: center;
  margin: auto;
  padding: 2px;
  padding-left:4px;
  padding-right:4px;
}

.jtoolbar-mobile .jtoolbar-item {
  position: relative;
  flex:1;
}

.jtoolbar .jtoolbar-divisor {
  width: 2px;
  height: 18px;
  padding: 0px;
  margin-left: 4px;
  margin-right: 4px;
  background-color: #ddd;
}

.jtoolbar .jtoolbar-label {
  padding-left: 8px;
  padding-right: 8px;
}



.jtoolbar-mobile a
{
  text-decoration:none;
  display:inline-block;
}

.jtoolbar-mobile i {
  display: inline-flex !important;
  color:#929292;
}

.jtoolbar-mobile span {
  font-size:0.7em;
  display:block;
  color:#929292;
}

.jtoolbar-mobile .jtoolbar-selected a, .jtoolbar-mobile .jtoolbar-selected i, .jtoolbar-mobile .jtoolbar-selected span {
  color:var(--active-color) !important;
  background-color:transparent;
}

.jtoolbar-item {
  -webkit-user-select: none;
  -moz-user-select: none;
  -ms-user-select: none;
  user-select: none;
}

.jtoolbar-item i {
  display: block;
  color:#333;
}

.jtoolbar-item:hover {
  background-color:#f2f2f2;
}


.jtoolbar .jpicker {
  padding-left:0px;
  padding-right:0px;
}

.jtoolbar .jpicker-header {
  height: 24px;
  line-height: 24px;
  padding: 0px;
  padding-right: 20px;
  padding-left: 8px;
  background-position: top 50% right 0px;
  display: flex;
  align-items: center;
}

.jtoolbar .jpicker-content > div {
  padding: 6px;
}

.jtoolbar-active {
  background-color:#eee;
}

.jtoolbar .fa {
  width: 18px;
  height: 18px;
  display: block;
  line-height: 18px;
  font-size: 14px;
}

.jtoolbar .material-icons {
  font-size: 18px;
  width: 24px;
  height: 24px;
  display: block;
  line-height: 24px;
  transform: rotate(0.03deg);
  text-align: center;
}

.jtoolbar .jtoolbar-arrow {
  background-repeat: no-repeat;
  background-position: center;
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_25___});
  width: 24px;
  height: 16px;
  margin-left: 4px;
  border-left: 1px solid #f2f2f2;
}

.jtoolbar-floating {
  position: absolute;
  display: none;
  box-shadow: 0 4px 5px 0 rgba(0,0,0,0.14), 0 1px 10px 0 rgba(0,0,0,0.12), 0 2px 4px -1px rgba(0,0,0,0.2);
  border-radius: 4px;
  background-color: #fff;
  padding: 4px;
  z-index: 50;
  text-align: left;
}

.jtoolbar-floating .jtoolbar-divisor {
  display: none;
}

.jtoolbar-arrow-selected .jtoolbar-floating {
  display: flex;
  flex-wrap: wrap;
}

`, "",{"version":3,"sources":["webpack://./src/assets/lib/jsuites/dist/jsuites.css"],"names":[],"mappings":";AACA;;;;;;;;EAQE;;AAEF;EACE,uBAAuB;EACvB,uBAAuB;EACvB,yCAAyC;EACzC,+CAA+C;AACjD;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;EACE,2BAA2B;EAC3B,yBAAyB;EACzB,wBAAwB;EACxB,sBAAsB;EACtB,qBAAqB;EACrB,iBAAiB;AACnB;;AAEA;EACE,oBAAoB;AACtB;;AAEA;EACE,WAAW;EACX,yBAAyB;AAC3B;;AAEA;EACE,kBAAkB;EAClB,sBAAsB;EACtB,wBAAwB;EACxB,YAAY;EACZ,mBAAmB;EACnB,YAAY;EACZ,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,eAAe;EACf,6BAA6B;EAC7B,WAAW;EACX,kBAAkB;EAClB,UAAU;AACZ;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,cAAc;EACd,eAAe;EACf,YAAY;AACd;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,YAAY;EACZ,YAAY;EACZ,iBAAiB;EACjB,iBAAiB;EACjB,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,uBAAuB;EACvB,eAAe;EACf,sBAAsB;EACtB,WAAW;EACX,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA;EACE,gBAAgB;EAChB,6BAA6B;EAC7B,eAAe;EACf,WAAW;EACX,WAAW;EACX,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,kBAAkB;EAClB,WAAW;AACb;;AAEA;EACE,mBAAmB;EACnB,kBAAkB;EAClB,qBAAqB;EACrB,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,uBAAuB;EACvB,eAAe;EACf,sBAAsB;EACtB,WAAW;EACX,gBAAgB;EAChB,iBAAiB;EACjB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;AACzB;;AAEA;EACE,gBAAgB;EAChB,6BAA6B;EAC7B,eAAe;EACf,WAAW;EACX,WAAW;EACX,YAAY;AACd;;AAEA;EACE,YAAY;EACZ,yBAAyB;AAC3B;;AAEA;EACE,qBAAqB;AACvB;;;;AAIA,iBAAiB;AACjB;EACE,8BAA8B;AAChC;;AAEA;EACE,+BAA+B;AACjC;;AAEA;EACE,kBAAkB;EAClB,sCAAsC;AACxC;;AAEA;EACE,kBAAkB;EAClB,uCAAuC;AACzC;;AAEA;EACE,kBAAkB;EAClB,uCAAuC;AACzC;;AAEA;EACE,kBAAkB;EAClB,wCAAwC;AAC1C;;AAEA;EACE,kBAAkB;EAClB,qCAAqC;AACvC;;AAEA;EACE,kBAAkB;EAClB,sCAAsC;AACxC;;AAEA;EACE,kBAAkB;EAClB,wCAAwC;AAC1C;;AAEA;EACE,kBAAkB;EAClB,yCAAyC;AAC3C;;AAEA;EACE,kCAAkC;AACpC;;AAEA,yBAAyB;AACzB;EACE,KAAK,UAAU,EAAE;EACjB,OAAO,YAAY,EAAE;AACvB;;AAEA;EACE,KAAK,UAAU,EAAE;EACjB,OAAO,YAAY,EAAE;AACvB;;AAEA;EACE,KAAK,YAAY,EAAE;EACnB,OAAO,UAAU,EAAE;AACrB;;AAEA;EACE,KAAK,YAAY,EAAE;EACnB,OAAO,UAAU,EAAE;AACrB;;AAEA,8BAA8B;AAC9B;EACE,KAAK,WAAW,EAAE;EAClB,OAAO,QAAQ,EAAE;AACnB;;AAEA;EACE,KAAK,WAAW,EAAE;EAClB,OAAO,QAAQ,EAAE;AACnB;;AAEA;EACE,KAAK,QAAQ,EAAE;EACf,OAAO,WAAW,EAAE;AACtB;;AAEA;EACE,KAAK,QAAQ,EAAE;EACf,OAAO,WAAW,EAAE;AACtB;;AAEA,8BAA8B;AAC9B;EACE,KAAK,UAAU,EAAE;EACjB,OAAO,QAAQ,EAAE;AACnB;;AAEA;;EAEE,KAAK,UAAU,EAAE;EACjB,OAAO,QAAQ,EAAE;AACnB;;AAEA;EACE,KAAK,QAAQ,EAAE;EACf,OAAO,UAAU,EAAE;AACrB;;AAEA;EACE,KAAK,QAAQ,EAAE;EACf,OAAO,UAAU,EAAE;AACrB;;AAEA,8BAA8B;AAC9B;EACE,KAAK,4BAA4B,EAAE;EACnC,OAAO,yBAAyB,EAAE;AACpC;;AAEA;EACE,KAAK,4BAA4B,EAAE;EACnC,OAAO,iCAAiC,EAAE;AAC5C;;AAEA;EACE,KAAK,yBAAyB,EAAE;EAChC,OAAO,4BAA4B,EAAE;AACvC;;AAEA;EACE,KAAK,iCAAiC,EAAE;EACxC,OAAO,oCAAoC,EAAE;AAC/C;;AAEA,8BAA8B;AAC9B;EACE,KAAK,2BAA2B,EAAE;EAClC,OAAO,yBAAyB,EAAE;AACpC;;AAEA;EACE,KAAK,2BAA2B,EAAE;EAClC,OAAO,iCAAiC,EAAE;AAC5C;;AAEA;EACE,KAAK,yBAAyB,EAAE;EAChC,OAAO,2BAA2B,EAAE;AACtC;;AAEA;EACE,KAAK,iCAAiC,EAAE;EACxC,OAAO,mCAAmC,EAAE;AAC9C;;AAEA;EACE;MACI,8BAA8B;EAClC;EACA;MACI,gCAAgC;EACpC;AACF;;AAEA;EACE;MACI,sBAAsB;EAC1B;EACA;MACI,wBAAwB;EAC5B;AACF;;AAEA;EACE,iBAAiB;EACjB,YAAY;EACZ,YAAY;EACZ,qBAAqB;EACrB,2BAA2B;EAC3B,yBAAyB;EACzB,wBAAwB;EACxB,sBAAsB;EACtB,qBAAqB;EACrB,iBAAiB;EACjB,0CAA0C;EAC1C,wCAAwC;EACxC,eAAe;AACjB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,cAAc;EACd,OAAO;EACP,QAAQ;EACR,YAAY;EACZ,cAAc;EACd,eAAe;EACf,gCAAgC;EAChC,UAAU;EACV,WAAW;EACX,YAAY;AACd;;AAEA;EACE,iBAAiB;EACjB,qBAAqB;AACvB;;AAEA;EACE,iBAAiB;EACjB,YAAY;EACZ,oDAAoD;EACpD,iDAAiD;EACjD,4CAA4C;EAC5C,qBAAqB;AACvB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,gBAAgB;EAChB,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,wDAA8Q;EAC9Q,0BAA0B;EAC1B,2BAA2B;AAC7B;;AAEA;EACE,cAAc;EACd,wDAA4Q;EAC5Q,0BAA0B;EAC1B,2BAA2B;AAC7B;;AAEA;EACE,gBAAgB;EAChB,yBAAyB;EACzB,aAAa;AACf;;AAEA;EACE,UAAU;EACV,qBAAqB;AACvB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,YAAY;EACZ,WAAW;AACb;;AAEA;EACE,qBAAqB;EACrB,cAAc;EACd,WAAW;EACX,eAAe;AACjB;;;AAGA;EACE,YAAY;AACd;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,kBAAkB;EAClB,wDAA+T;EAC/T,qCAAqC;EACrC,2BAA2B;EAC3B,sBAAsB;AACxB;;AAEA;EACE,oDAAoD;EACpD,iDAAiD;EACjD,4CAA4C;EAC5C,qBAAqB;AACvB;;AAEA;EACE,qBAAqB;EACrB,qBAAqB;EACrB,iBAAiB;EACjB,WAAW;EACX,UAAU;AACZ;;AAEA;EACE,UAAU;EACV,oBAAoB;EACpB,UAAU;EACV,WAAW;EACX,iBAAiB;EACjB,eAAe;EACf,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,wBAAwB;EACxB,cAAc;EACd,0BAA0B;AAC5B;;AAEA;EACE,YAAY;;EAEZ,8BAA8B;EAC9B,sBAAsB;EACtB,qBAAqB;;EAErB,oBAAoB;EACpB,iBAAiB;EACjB,oBAAoB;EACpB,qBAAqB;EACrB,aAAa;;EAEb,2BAA2B;EAC3B,8BAA8B;EAC9B,kBAAkB;AACpB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,UAAU;EACV,OAAO;EACP,QAAQ;AACV;;AAEA;;EAEE,cAAc;EACd,UAAU;EACV,QAAQ;EACR,UAAU;AACZ;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,UAAU;AACZ;AACA;EACE,WAAW;AACb;;AAEA;EACE,YAAY;AACd;;;AAGA;EACE,aAAa;EACb,aAAa;AACf;;AAEA;EACE,kBAAkB;EAClB,yDAA8pB;EAC9pB,qCAAqC;EACrC,2BAA2B;EAC3B,sBAAsB;AACxB;;AAEA;EACE,kBAAkB;EAClB,aAAa;EACb,iBAAiB;EACjB,mCAAmC;EACnC,kBAAkB;EAClB,oBAAoB;EACpB,0BAA0B;EAC1B,kBAAkB;EAClB,oHAAoH;EACpH,4GAA4G;EAC5G,qBAAqB;EACrB,sBAAsB;EACtB,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,aAAa;EACb,6BAA6B;EAC7B,kBAAkB;AACpB;;AAEA;EACE,OAAO;EACP,cAAc;EACd,0BAA0B;EAC1B,yBAAyB;EACzB,iBAAiB;EACjB,sBAAsB;AACxB;;AAEA;EACE,yBAAyB;EACzB,sBAAsB;AACxB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,UAAU;EACV,WAAW;EACX,iBAAiB;AACnB;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,2BAA2B;EAC3B,qBAAqB;EACrB,2BAA2B;EAC3B,yDAAoQ;AACtQ;;AAEA;EACE,eAAe;EACf,SAAS;EACT,WAAW;EACX,UAAU;EACV,iBAAiB;EACjB,kBAAkB;EAClB,sBAAsB;AACxB;;AAEA;EACE,aAAa;EACb,oDAAoD;EACpD,iDAAiD;EACjD,4CAA4C;AAC9C;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,eAAe;EACf,QAAQ;EACR,SAAS;EACT,eAAe;EACf,gBAAgB;EAChB,iCAAiC;EACjC,WAAW;EACX,YAAY;EACZ,aAAa;EACb,aAAa;;AAEf,2BAA2B,EAAE,eAAe;EAC1C,yBAAyB,EAAE,WAAW;GACrC,wBAAwB,EAAE,mBAAmB;KAC3C,sBAAsB,EAAE,YAAY;MACnC,qBAAqB,EAAE,2BAA2B;UAC9C,iBAAiB,EAAE;+DACkC;AAC/D;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,2BAA2B;AAC7B;;AAEA;EACE,4BAA4B;AAC9B;;AAEA;EACE,8BAA8B;AAChC;;AAEA;EACE,+BAA+B;AACjC;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,YAAY;EACZ,kBAAkB;AACpB;;AAEA;EACE,cAAc;EACd,kBAAkB;EAClB,uBAAuB;AACzB;;AAEA;EACE,WAAW;EACX,UAAU;EACV,sBAAsB;EACtB,kBAAkB;EAClB,QAAQ;EACR,SAAS;EACT,gCAAgC;EAChC,kBAAkB;AACpB;;AAEA;EACE,4BAA4B;AAC9B;;AAEA;EACE,wBAAwB;;EAExB,YAAY;EACZ,UAAU;;EAEV,mBAAmB;EACnB,UAAU;;EAEV,mBAAmB;EACnB,aAAa;AACf;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,yBAAyB;EACzB,cAAc;AAChB;;AAEA;EACE,WAAW;EACX,YAAY;AACd;;AAEA;EACE,wBAAwB;EACxB,YAAY;EACZ,WAAW;EACX,kBAAkB;EAClB,gBAAgB;EAChB,sBAAsB;EACtB,eAAe;AACjB;;AAEA;EACE,wBAAwB;EACxB,YAAY;EACZ,WAAW;EACX,kBAAkB;EAClB,gBAAgB;EAChB,sBAAsB;EACtB,eAAe;AACjB;;AAEA;EACE,YAAY;EACZ,gBAAgB;EAChB,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,yBAAyB;AAC3B;;AAEA;EACE,wBAAwB;AAC1B;;AAEA;EACE,wBAAwB;EACxB,uBAAuB;EACvB,YAAY;AACd;;AAEA;EACE,uBAAuB;EACvB,6BAA6B;EAC7B,8BAA8B;EAC9B,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,aAAa;EACb,eAAe;EACf,WAAW;EACX,eAAe;EACf,yBAAyB;EACzB,sBAAsB;EACtB,iBAAiB;EACjB,0DAA0D;EAC1D,uDAAuD;EACvD,kDAAkD;EAClD,yBAAyB;EACzB,YAAY;EACZ,eAAe;EACf,kBAAkB;EAClB,UAAU;EACV,YAAY;EACZ,YAAY;AACd;;AAEA;EACE,oBAAoB;AACtB;;AAEA;EACE,sBAAsB;EACtB,aAAa;EACb,yBAAyB;EACzB,YAAY;EACZ,kBAAkB;EAClB,eAAe;EACf,eAAe;EACf,sBAAsB;EACtB,gBAAgB;AAClB;;AAEA;EACE,wBAAwB;EACxB,wCAAwC;EACxC,mBAAmB;EACnB,kBAAkB;EAClB,eAAe;EACf,cAAc;EACd,sBAAsB;EACtB,oBAAoB;EACpB,qBAAqB;EACrB,mBAAmB;EACnB,iBAAiB;EACjB,cAAc;EACd,qCAAqC;EACrC,mCAAmC;EACnC,kBAAkB;EAClB,SAAS;AACX;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,WAAW;EACX,qBAAqB;EACrB,OAAO;AACT;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,yBAAyB;EACzB,gBAAgB;EAChB,cAAc;EACd,iBAAiB;AACnB;;AAEA;EACE,uBAAuB;AACzB;;AAEA;EACE,QAAQ;EACR,SAAS;EACT,UAAU;EACV,kBAAkB;AACpB;;AAEA;EACE,cAAc;EACd,UAAU;EACV,2CAA2C;EAC3C,mCAAmC;EACnC,oBAAoB;AACtB;;AAEA;EACE;MACI,uBAAuB;MACvB,oBAAoB;MACpB,sBAAsB;MACtB,YAAY;MACZ,aAAa;MACb,gBAAgB;MAChB,wCAAwC;MACxC,gBAAgB;EACpB;EACA;MACI,WAAW;MACX,kBAAkB;MAClB,6BAA6B;MAC7B,aAAa;EACjB;EACA;MACI,2BAA2B;MAC3B,YAAY;MACZ,QAAQ;MACR,gBAAgB;MAChB,UAAU;EACd;EACA;MACI,gBAAgB;EACpB;;EAEA;MACI,iBAAiB;EACrB;;EAEA;MACI,wBAAwB;MACxB,wCAAwC;MACxC,mBAAmB;MACnB,kBAAkB;MAClB,eAAe;MACf,cAAc;MACd,sBAAsB;MACtB,oBAAoB;MACpB,qBAAqB;MACrB,mBAAmB;MACnB,iBAAiB;MACjB,cAAc;MACd,qCAAqC;MACrC,mCAAmC;MACnC,kBAAkB;MAClB,SAAS;EACb;EACA;MACI,gBAAgB;MAChB,yBAAyB;EAC7B;EACA;MACI,aAAa;EACjB;EACA;MACI,aAAa;EACjB;EACA;MACI,aAAa;EACjB;AACF;;;AAGA;EACE,cAAc;EACd,2BAA2B;EAC3B,yBAAyB;EACzB,wBAAwB;EACxB,sBAAsB;EACtB,qBAAqB;EACrB,iBAAiB;EACjB,sBAAsB;EACtB,eAAe;EACf,wCAAwC;EACxC,qBAAqB;AACvB;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,cAAc;EACd,OAAO;EACP,QAAQ;EACR,cAAc;EACd,eAAe;EACf,gCAAgC;EAChC,UAAU;EACV,WAAW;EACX,YAAY;EACZ,YAAY;AACd;;AAEA;EACE,YAAY;EACZ,oBAAoB;AACtB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,6BAA6B;AAC/B;;AAEA;EACE,yCAAyC;AAC3C;;AAEA;EACE,yDAA0U;AAC5U;;AAEA;;EAEE,WAAW;EACX,UAAU;EACV,iBAAiB;AACnB;;AAEA;;EAEE,UAAU;EACV,gBAAgB;EAChB,4BAA4B;EAC5B,qCAAqC;EACrC,yDAAuO;EACvO,uBAAuB;EACvB,cAAc;EACd,sBAAsB;EACtB,wBAAwB;EACxB,qBAAqB;EACrB,6BAA6B;AAC/B;;AAEA;;EAEE,gBAAgB;EAChB,yBAAyB;EACzB,iBAAiB;EACjB,WAAW;EACX,QAAQ;EACR,YAAY;AACd;;AAEA;;EAEE,kBAAkB;EAClB,oCAAoC;EACpC,iBAAiB;EACjB,YAAY;AACd;;AAEA;;EAEE,YAAY;EACZ,aAAa;EACb,0BAA0B;EAC1B,wBAAwB;EACxB,gBAAgB;EAChB,YAAY;EACZ,gBAAgB;AAClB;;AAEA;;EAEE,iBAAiB;EACjB,UAAU;EACV,qBAAqB;AACvB;;AAEA;;AAEA;;AAEA;;EAEE,mBAAmB;EACnB,gBAAgB;EAChB,uBAAuB;EACvB,kBAAkB;EAClB,WAAW;EACX,aAAa;EACb,mBAAmB;AACrB;;AAEA;;EAEE,uBAAuB;EACvB,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;;EAEE,iBAAiB;EACjB,WAAW;EACX,YAAY;EACZ,kBAAkB;AACpB;;AAEA;;EAEE,UAAU;EACV,WAAW;AACb;;AAEA;;EAEE,iBAAiB;EACjB,eAAe;EACf,iBAAiB;AACnB;;AAEA;;EAEE,eAAe;EACf,gBAAgB;AAClB;;AAEA;;EAEE,gBAAgB;EAChB,uBAAuB;EACvB,kBAAkB;EAClB,cAAc;AAChB;;AAEA,qBAAqB;;AAErB;;EAEE,qBAAqB;EACrB,WAAW;EACX,iBAAiB;EACjB,kBAAkB;AACpB;;AAEA;;EAEE,qBAAqB;AACvB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,aAAa;AACf;;AAEA;;EAEE,iBAAiB;EACjB,wBAAwB;EACxB,UAAU;EACV,qBAAqB;EACrB,qBAAqB;EACrB,eAAe;EACf,gBAAgB;EAChB,eAAe;AACjB;;AAEA;;EAEE,WAAW;EACX,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;;EAEE,wBAAwB;EACxB,UAAU;AACZ;;AAEA;;EAEE,qBAAqB;AACvB;;AAEA;;EAEE,yDAAmU;EACnU,2BAA2B;EAC3B,qCAAqC;EACrC,wBAAwB;EACxB,UAAU;AACZ;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,iBAAiB;EACjB,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,iBAAiB;EACjB,KAAK;EACL,OAAO;EACP,UAAU;EACV,iBAAiB;EACjB,cAAc;EACd,UAAU;EACV,cAAc;EACd,6BAA6B;EAC7B,YAAY;EACZ,kBAAkB;AACpB;;AAEA;EACE,aAAa;AACf;;AAEA,gCAAgC;;AAEhC;EACE,aAAa;AACf;;AAEA;EACE,aAAa;AACf;;AAEA;;EAEE,cAAc;EACd,UAAU;EACV,QAAQ;EACR,+BAA+B;EAC/B,UAAU;EACV,qBAAqB;EACrB,sBAAsB;AACxB;;AAEA;;EAEE,qDAAqD;EACrD,kDAAkD;EAClD,6CAA6C;EAC7C,qBAAqB;EACrB,aAAa;AACf;;AAEA;;EAEE,iBAAiB;EACjB,YAAY;EACZ,wBAAwB;EACxB,4BAA4B;AAC9B;;AAEA;;EAEE,cAAc;EACd,yBAAyB;EACzB,gBAAgB;EAChB,mBAAmB;EACnB,cAAc;EACd,gCAAgC;EAChC,iBAAiB;EACjB,kBAAkB;EAClB,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;;EAEE,cAAc;EACd,yBAAyB;EACzB,gBAAgB;EAChB,mBAAmB;EACnB,gCAAgC;EAChC,iBAAiB;EACjB,kBAAkB;AACpB;;AAEA;;EAEE,yDAAmU;EACnU,2BAA2B;EAC3B,sCAAsC;EACtC,wBAAwB;EACxB,UAAU;AACZ;;AAEA;;EAEE,wBAAwB;EACxB,UAAU;AACZ;;AAEA,0CAA0C;;AAE1C;;EAEE,cAAc;EACd,kBAAkB;EAClB,mBAAmB;EACnB,qBAAqB;EACrB,sBAAsB;EACtB,wBAAwB;EACxB,WAAW;EACX,YAAY;EACZ,iBAAiB;EACjB,4BAA4B;EAC5B,iCAAiC;AACnC;;AAEA;;EAEE,eAAe;EACf,QAAQ;EACR,SAAS;EACT,aAAa;EACb,YAAY;EACZ,qBAAqB;EACrB,oCAAoC;EACpC,gBAAgB;EAChB,WAAW;AACb;;AAEA;;EAEE,WAAW;EACX,4BAA4B;EAC5B,yBAAyB;EACzB,0BAA0B;EAC1B,yDAAqjB;EACrjB,6BAA6B;EAC7B,8BAA8B;AAChC;;AAEA;;EAEE,aAAa;AACf;;AAEA;EACE,aAAa;AACf;;AAEA;;EAEE,gBAAgB;EAChB,UAAU;AACZ;;AAEA;;EAEE,cAAc;EACd,OAAO;EACP,SAAS;AACX;;AAEA;;EAEE,eAAe;AACjB;;AAEA;;EAEE,eAAe;EACf,kBAAkB;EAClB,qBAAqB;AACvB;;AAEA;;EAEE,6BAA6B;EAC7B,gCAAgC;EAChC,YAAY;EACZ,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;;EAEE,WAAW;EACX,UAAU;EACV,WAAW;EACX,2BAA2B;AAC7B;;AAEA;;EAEE,yDAAqT;AACvT;;AAEA;;EAEE,0DAAyS;AAC3S;;AAEA;;EAEE,gBAAgB;EAChB,mBAAmB;EACnB,gCAAgC;EAChC,iBAAiB;EACjB,kBAAkB;EAClB,qBAAqB;EACrB,eAAe;AACjB;;AAEA;EACE,uBAAuB;EACvB,gBAAgB;EAChB,4BAA4B;AAC9B;;AAEA;;EAEE,6BAA6B;AAC/B;;AAEA;;EAEE,0DAAmU;EACnU,2BAA2B;EAC3B,sCAAsC;AACxC;;AAEA,kBAAkB;;AAElB;;AAEA;;AAEA;;EAEE,aAAa;AACf;;AAEA;;EAEE,YAAY;AACd;;AAEA;;EAEE,qBAAqB;AACvB;;AAEA;;EAEE,gCAAgC;EAChC,gBAAgB;EAChB,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;;EAEE,gBAAgB;EAChB,mBAAmB;EACnB,gCAAgC;EAChC,iBAAiB;EACjB,kBAAkB;EAClB,qBAAqB;AACvB;;AAEA;;EAEE,0DAAmU;EACnU,2BAA2B;EAC3B,sCAAsC;AACxC;;AAEA;;EAEE;MACI,qBAAqB;MACrB,UAAU;MACV,WAAW;EACf;;EAEA;MACI,cAAc;EAClB;;EAEA;MACI,yBAAyB;EAC7B;AACF;;AAEA;EACE,wBAAwB;AAC1B;;AAEA;EACE,YAAY;EACZ,sBAAsB;EACtB,kBAAkB;EAClB,YAAY;AACd;;AAEA;EACE,sBAAsB;EACtB,6BAA6B;EAC7B,mBAAmB;EACnB,WAAW;EACX,YAAY;EACZ,iBAAiB;AACnB;;AAEA;EACE,YAAY;EACZ,oBAAoB;AACtB;;AAEA;EACE,qBAAqB;EACrB,sBAAsB;AACxB;;AAEA;GACG,sBAAsB;AACzB;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,YAAY;EACZ,sBAAsB;;AAExB;;AAEA;EACE,+BAA+B;EAC/B,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;EAChB,kBAAkB;EAClB,YAAY;AACd;;AAEA,cAAc;;AAEd;EACE,eAAe;EACf,cAAc;EACd,sBAAsB;EACtB,iBAAiB;AACnB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,YAAY;EACZ,eAAe;AACjB;;AAEA;EACE,iBAAiB;EACjB,kBAAkB;EAClB,aAAa;AACf;;AAEA;EACE,YAAY;EACZ,wBAAwB;EACxB,eAAe;EACf,UAAU;EACV,gBAAgB;AAClB;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,gBAAgB;EAChB,6BAA6B;EAC7B,eAAe;EACf,WAAW;EACX,YAAY;EACZ,iBAAiB;EACjB,eAAe;EACf,6BAA6B;EAC7B,kBAAkB;EAClB,SAAS;EACT,WAAW;AACb;;AAEA;EACE,yBAAyB;EACzB,wBAAwB;EACxB,sBAAsB;EACtB,oBAAoB;EACpB,iBAAiB;;EAEjB,uBAAuB;EACvB,sBAAsB;EACtB,oBAAoB;EACpB,kBAAkB;AACpB;;AAEA;EACE,4BAA4B;EAC5B,sBAAsB;AACxB;;AAEA;EACE,yBAAyB;EACzB,wBAAwB;EACxB,sBAAsB;EACtB,oBAAoB;EACpB,iBAAiB;;EAEjB,uBAAuB;EACvB,sBAAsB;EACtB,oBAAoB;EACpB,kBAAkB;AACpB;;AAEA;EACE,wBAAwB;EACxB,gBAAgB;AAClB;;AAEA;EACE,0DAAwwD;EACxwD,4BAA4B;EAC5B,sBAAsB;EACtB,UAAU;EACV,WAAW;AACb;;AAEA;EACE,kBAAkB;EAClB,eAAe;EACf,sBAAsB;AACxB;;AAEA;EACE,cAAc;EACd,aAAa;EACb,UAAU;EACV,MAAM;EACN,OAAO;EACP,KAAK;EACL,QAAQ;EACR,iCAAiC;AACnC;;AAEA;EACE,UAAU;EACV,aAAa;EACb,aAAa;EACb,eAAe;EACf,UAAU;EACV,WAAW;EACX,kBAAkB;EAClB,kBAAkB;EAClB,4BAA4B;EAC5B,gBAAgB;EAChB,iBAAiB;EACjB,2CAA2C;EAC3C,mCAAmC;AACrC;;AAEA;EACE,4BAA4B;AAC9B;;AAEA;EACE,aAAa;EACb,eAAe;EACf,iBAAiB;EACjB,4BAA4B;AAC9B;;;AAGA;EACE,cAAc;EACd,OAAO;EACP,QAAQ;EACR,SAAS;EACT,UAAU;EACV,6CAA6C;EAC7C,0CAA0C;EAC1C,qBAAqB;EACrB,qBAAqB;EACrB,gCAAgC;EAChC,sBAAsB;EACtB,2BAA2B;EAC3B,YAAY;EACZ,kBAAkB;AACpB;;AAEA;EACE,iBAAiB;EACjB,KAAK;EACL,MAAM;EACN,UAAU;EACV,mBAAmB;EACnB,YAAY;EACZ,sBAAsB;EACtB,eAAe;EACf,sCAAsC;EACtC,sBAAsB;EACtB,8BAA8B;AAChC;;AAEA;EACE,YAAY;EACZ,eAAe;EACf,eAAe;EACf,sBAAsB;EACtB,8BAA8B;AAChC;AACA;EACE,+BAA+B;AACjC;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,UAAU;EACV,0DAA2S;EAC3S,iBAAiB;EACjB,KAAK;EACL,OAAO;EACP,WAAW;EACX,cAAc;EACd,UAAU;EACV,WAAW;EACX,cAAc;EACd,6BAA6B;AAC/B;;AAEA;EACE,sBAAsB;EACtB,uBAAuB;EACvB,QAAQ;EACR,SAAS;EACT,eAAe;EACf,WAAW;EACX,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,QAAQ;EACR,SAAS;EACT,eAAe;EACf,gBAAgB;EAChB,iCAAiC;EACjC,WAAW;EACX,YAAY;EACZ,aAAa;EACb,aAAa;;AAEf,2BAA2B,EAAE,eAAe;EAC1C,yBAAyB,EAAE,WAAW;GACrC,wBAAwB,EAAE,mBAAmB;KAC3C,sBAAsB,EAAE,YAAY;MACnC,qBAAqB,EAAE,2BAA2B;UAC9C,iBAAiB,EAAE;+DACkC;AAC/D;;;AAGA;EACE,eAAe;EACf,cAAc;EACd,8BAA8B;EAC9B,sBAAsB;EACtB,aAAa;EACb,WAAW;AACb;;AAEA;EACE,wDAAwD;EACxD,gDAAgD;EAChD,aAAa;EACb,kBAAkB;;EAElB,sBAAsB;EACtB,4BAA4B;EAC5B,6EAA6E;EAC7E,WAAW;EACX,YAAY;EACZ,YAAY;EACZ,aAAa;AACf;;AAEA;EACE,WAAW;EACX,0DAAwT;EACxT,eAAe;EACf,WAAW;EACX,YAAY;EACZ,eAAe;AACjB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,yBAAyB;EACzB,gBAAgB;EAChB,OAAO;EACP,qBAAqB;AACvB;;AAEA;EACE,yBAAyB;EACzB,+EAA+E;AACjF;;AAEA;EACE;MACI,qCAAqC;MACrC,WAAW;EACf;EACA;MACI,kCAAkC;MAClC,sBAAsB;MACtB,WAAW;MACX,WAAW;MACX,cAAc;EAClB;EACA;MACI,kCAAkC;MAClC,cAAc;EAClB;EACA;MACI,0DAAwT;EAC5T;AACF;;AAEA;EACE,oBAAoB;EACpB,qBAAqB;EACrB,oBAAoB;EACpB,aAAa;EACb,uBAAuB;EACvB,mCAAmC;EACnC,oBAAoB;EACpB,2BAA2B;EAC3B,yBAAyB;EACzB,2BAA2B;EAC3B,sBAAsB;EACtB,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,mBAAmB;EACnB,oBAAoB;EACpB,yBAAyB;EACzB,sBAAsB;EACtB,qBAAqB;EACrB,iBAAiB;EACjB,aAAa;EACb,kBAAkB;AACpB;;AAEA;EACE,4BAA4B;EAC5B,sCAAsC;EACtC,yDAAuO;EACvO,uBAAuB;EACvB,eAAe;EACf,sBAAsB;EACtB,gBAAgB;EAChB,aAAa;;EAEb,iBAAiB;EACjB,YAAY;EACZ,kBAAkB;EAClB,mBAAmB;EACnB,aAAa;EACb,kBAAkB;AACpB;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,kBAAkB;EAClB,MAAM;EACN,aAAa;EACb,uGAAuG;EACvG,kBAAkB;EAClB,sBAAsB;EACtB,YAAY;EACZ,WAAW;EACX,gBAAgB;EAChB,iBAAiB;EACjB,qBAAqB;EACrB,iCAAiC;AACnC;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,YAAY;EACZ,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,wBAAwB;AAC1B;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,yBAAyB;EACzB,uBAAuB;EACvB,eAAe;AACjB;;;;AAIA;;EAEE,cAAc;EACd,2BAA2B;EAC3B,yBAAyB;EACzB,wBAAwB;EACxB,sBAAsB;EACtB,qBAAqB;EACrB,iBAAiB;EACjB,sBAAsB;EACtB,eAAe;EACf,wCAAwC;EACxC,qBAAqB;EACrB,sBAAsB;EACtB,cAAc;EACd,qBAAqB;EACrB,iBAAiB;AACnB;;AAEA;EACE,wBAAwB;EACxB,iBAAiB;EACjB,UAAU;EACV,gBAAgB;AAClB;;AAEA;;EAEE,UAAU;AACZ;;AAEA;EACE,0CAA0C;AAC5C;;AAEA;EACE,sBAAsB;EACtB,qBAAqB;EACrB,sBAAsB;EACtB,WAAW;AACb;;AAEA;EACE,YAAY;AACd;AACA;EACE,UAAU;EACV,WAAW;EACX,gBAAgB;EAChB,0DAAqZ;AACvZ;;AAEA;EACE,0DAAuV;EACvV,YAAY;AACd;;AAEA;EACE,0DAAqV;AACvV;;;AAGA;EACE,kBAAkB;EAClB,aAAa;EACb,yBAAyB;EACzB,sBAAsB;EACtB,qBAAqB;EACrB,iBAAiB;AACnB;;AAEA;EACE,kBAAkB;EAClB,gFAAgF;EAChF,YAAY;EACZ,0BAA0B;EAC1B,kBAAkB;EAClB,YAAY;EACZ,cAAc;;EAEd,6CAA6C;EAC7C,qCAAqC;EACrC,iCAAiC;EACjC,yBAAyB;EACzB,gBAAgB;EAChB,gCAAgC;EAChC,eAAe;EACf,SAAS;EACT,gBAAgB;EAChB,aAAa;EACb,WAAW;EACX,yBAAyB;EACzB,sBAAsB;EACtB,qBAAqB;EACrB,iBAAiB;AACnB;;AAEA;EACE,+BAA+B;AACjC;;AAEA;EACE,WAAW;EACX,eAAe;EACf,oBAAoB;EACpB,qBAAqB;EACrB,aAAa;EACb,iBAAiB;EACjB,iBAAiB;EACjB,2BAA2B;EAC3B,mBAAmB;;EAEnB,yBAAyB;EACzB,sBAAsB;EACtB,qBAAqB;EACrB,iBAAiB;AACnB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,iBAAiB;EACjB,mBAAmB;EACnB,iBAAiB;AACnB;;AAEA;EACE,gBAAgB;EAChB,uBAAuB;EACvB,gBAAgB;EAChB,gBAAgB;EAChB,mBAAmB;EACnB,iBAAiB;AACnB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,sBAAsB;EACtB,uBAAuB;AACzB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,eAAe;EACf,UAAU;EACV,QAAQ;EACR,wBAAwB;EACxB,WAAW;EACX,WAAW;EACX,YAAY;EACZ,6BAA6B;EAC7B,eAAe;EACf,mCAAmC;EACnC,sCAAsC;EACtC,kBAAkB;EAClB,eAAe;AACjB;;AAEA;EACE,eAAe;EACf,WAAW;EACX,QAAQ;EACR,4BAA4B;EAC5B,WAAW;EACX,WAAW;EACX,YAAY;EACZ,6BAA6B;EAC7B,eAAe;EACf,mCAAmC;EACnC,sCAAsC;EACtC,kBAAkB;EAClB,eAAe;AACjB;;AAEA;EACE,UAAU;EACV,WAAW;EACX,0DAAwT;EACxT,cAAc;EACd,QAAQ;EACR,UAAU;EACV,cAAc;EACd,YAAY;;EAEZ,yBAAyB;AAC3B;;AAEA;EACE,WAAW;EACX,6BAA6B;EAC7B,cAAc;EACd,SAAS;EACT,2BAA2B;EAC3B,YAAY;EACZ,cAAc;EACd,YAAY;;EAEZ,aAAa;EACb,qBAAqB;EACrB,+BAA+B;EAC/B,2BAA2B;EAC3B,2BAA2B;EAC3B,uBAAuB;EACvB,mBAAmB;EACnB,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,eAAe;EACf,uBAAuB;EACvB,mBAAmB;EACnB,gBAAgB;EAChB,QAAQ;EACR,UAAU;EACV,YAAY;EACZ,WAAW;EACX,eAAe;;EAEf,yBAAyB;AAC3B;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,gBAAgB;EAChB,kBAAkB;EAClB,eAAe;;EAEf,yBAAyB;AAC3B;;AAEA;EACE,gCAAgC;EAChC,oBAAoB;AACtB;;AAEA;EACE,cAAc;EACd,MAAM;EACN,KAAK;EACL,WAAW;EACX,eAAe;EACf,eAAe;EACf,YAAY;EACZ,UAAU;EACV,qBAAqB;;EAErB,gCAAgC;EAChC,iCAAiC;EACjC,yBAAyB;EACzB,aAAa;EACb,sBAAsB;EACtB,2BAA2B;EAC3B,yBAAyB;;EAEzB,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,sBAAsB;EACtB,aAAa;EACb,qBAAqB;EACrB,YAAY;AACd;;AAEA;EACE,WAAW;EACX,uBAAuB;EACvB,YAAY;AACd;;AAEA;EACE;MACI,sBAAsB;MACtB,uBAAuB;EAC3B;;EAEA;MACI,uBAAuB;MACvB,uBAAuB;EAC3B;AACF;;AAEA;EACE,iBAAiB;EACjB,aAAa;EACb,aAAa;EACb,kBAAkB;AACpB;;AAEA;EACE,yBAAyB;EACzB,8BAA8B;AAChC;;AAEA;EACE,yBAAyB;EACzB,8BAA8B;AAChC;;AAEA;EACE,yBAAyB;EACzB,8BAA8B;AAChC;;AAEA;EACE,aAAa;EACb,WAAW;EACX,YAAY;EACZ,iBAAiB;AACnB;;AAEA;EACE,6BAA6B;EAC7B,gBAAgB;EAChB,iBAAiB;EACjB,WAAW;EACX,WAAW;EACX,WAAW;AACb;;AAEA;EACE,kBAAkB;EAClB,eAAe;EACf,cAAc;EACd,WAAW;EACX,cAAc;AAChB;;AAEA;EACE,kBAAkB;EAClB,eAAe;EACf,cAAc;EACd,WAAW;EACX,cAAc;AAChB;;AAEA;EACE,sBAAsB;EACtB,mBAAmB;EACnB,kBAAkB;EAClB,eAAe;AACjB;;AAEA;EACE,kBAAkB;EAClB,eAAe;EACf,cAAc;EACd,WAAW;EACX,cAAc;AAChB;;AAEA;EACE,kBAAkB;EAClB,eAAe;EACf,cAAc;EACd,WAAW;EACX,cAAc;AAChB;;AAEA;EACE,sBAAsB;EACtB,mBAAmB;EACnB,kBAAkB;EAClB,eAAe;AACjB;;AAEA;EACE,kBAAkB;EAClB,eAAe;EACf,cAAc;EACd,WAAW;EACX,cAAc;AAChB;;AAEA;EACE,kBAAkB;EAClB,eAAe;EACf,cAAc;EACd,WAAW;EACX,cAAc;AAChB;;AAEA;EACE,kBAAkB;EAClB,eAAe;EACf,cAAc;EACd,WAAW;EACX,cAAc;AAChB;;;AAGA;EACE,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,gBAAgB;EAChB,kBAAkB;AACpB;;;AAGA;EACE,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,YAAY;EACZ,kBAAkB;EAClB,mBAAmB;EACnB,gBAAgB;EAChB,iBAAiB;EACjB,yBAAyB;EACzB,eAAe;EACf,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,yBAAyB;EACzB,WAAW;AACb;;AAEA;EACE,WAAW;EACX,WAAW;EACX,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,YAAY;AACd;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,aAAa;EACb,sBAAsB;AACxB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,sBAAsB;EACtB,sBAAsB;EACtB,6CAA6C;EAC7C,yCAAyC;EACzC,aAAa;AACf;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,iBAAiB;EACjB,aAAa;EACb,eAAe;AACjB;;AAEA;EACE,eAAe;EACf,2BAA2B;EAC3B,4BAA4B;EAC5B,WAAW;EACX,YAAY;EACZ,iBAAiB;AACnB;;AAEA;EACE,iBAAiB;EACjB,0DAAmQ;AACrQ;;AAEA;EACE,iBAAiB;EACjB,0DAAwQ;AAC1Q;;AAEA;EACE,0DAAoQ;AACtQ;;AAEA;EACE,0DAAyQ;AAC3Q;;AAEA;EACE,0DAAwU;AAC1U;;AAEA,kBAAkB;;AAElB;EACE,YAAY;EACZ,kBAAkB;EAClB,mBAAmB;EACnB,sBAAsB;AACxB;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,8BAA8B;EAC9B,YAAY;EACZ,kBAAkB;AACpB;;AAEA;EACE,gCAAgC;AAClC;;AAEA;EACE,4CAA4C;AAC9C;;AAEA;EACE,aAAa;EACb,eAAe;EACf,uBAAuB;EACvB,2BAA2B;EAC3B,mBAAmB;EACnB,yBAAyB;EACzB,sCAAsC;EACtC,2BAA2B;EAC3B,YAAY;EACZ,sBAAsB;AACxB;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,WAAW;EACX,8BAA8B;AAChC;;AAEA;EACE,YAAY;EACZ,kBAAkB;EAClB,mBAAmB;EACnB,kBAAkB;EAClB,kBAAkB;EAClB,WAAW;EACX,cAAc;EACd,aAAa;AACf;;AAEA;EACE,YAAY;EACZ,gBAAgB;AAClB;;AAEA;EACE,YAAY;EACZ,kBAAkB;EAClB,QAAQ;EACR,UAAU;EACV,WAAW;EACX,YAAY;EACZ,eAAe;EACf,eAAe;EACf,aAAa;AACf;;AAEA;EACE,oCAAoC;AACtC;;AAEA;EACE,gCAAgC;AAClC;;AAEA;EACE,uBAAuB;AACzB;;AAEA;EACE,oCAAoC;EACpC,WAAW;AACb;;;AAGA;EACE,kBAAkB;EAClB,kBAAkB;EAClB,uGAAuG;EACvG,+BAA+B;AACjC;;AAEA;EACE,eAAe;EACf,mBAAmB;EACnB,aAAa;EACb,WAAW;EACX,yBAAyB;EACzB,sBAAsB;EACtB,qBAAqB;EACrB,iBAAiB;EACjB,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,cAAc;EACd,SAAS;EACT,SAAS;EACT,OAAO;EACP,WAAW;EACX,mBAAmB;EACnB,UAAU;EACV,sBAAsB;EACtB,qCAAqC;EACrC,kBAAkB;AACpB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,sBAAsB;EACtB,qBAAqB;EACrB,6BAA6B;AAC/B;;AAEA;EACE,aAAa;EACb,WAAW;AACb;;AAEA;EACE,kBAAkB;EAClB,YAAY;EACZ,YAAY;EACZ,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA;EACE,kBAAkB;EAClB,MAAM;AACR;;AAEA;EACE,UAAU;EACV,YAAY;EACZ,YAAY;EACZ,gBAAgB;EAChB,iBAAiB;EACjB,sBAAsB;AACxB;;AAEA;EACE,iBAAiB;EACjB,kBAAkB;AACpB;;;;AAIA;;EAEE,oBAAoB;EACpB,oBAAoB;AACtB;;AAEA;EACE,+BAA+B;EAC/B,aAAa;AACf;;AAEA;EACE,eAAe;EACf,aAAa;EACb,aAAa;AACf;;AAEA;EACE,oCAAoC;EACpC,4BAA4B;AAC9B;;AAEA;EACE,yBAAyB;EACzB,sBAAsB;EACtB,qBAAqB;EACrB,iBAAiB;AACnB;;AAEA;EACE,cAAc;EACd,UAAU;AACZ;;AAEA;EACE,wBAAwB;AAC1B;;;AAGA;EACE,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA;EACE,YAAY;EACZ,iBAAiB;EACjB,YAAY;EACZ,mBAAmB;EACnB,iBAAiB;EACjB,sCAAsC;EACtC,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,cAAc;EACd,iBAAiB;EACjB,eAAe;AACjB;;AAEA;EACE,eAAe;EACf,WAAW;EACX,YAAY;EACZ,cAAc;EACd,iBAAiB;EACjB,0BAA0B;EAC1B,kBAAkB;AACpB;;AAEA;EACE,4BAA4B;EAC5B,2BAA2B;EAC3B,0DAA2W;EAC3W,WAAW;EACX,YAAY;EACZ,gBAAgB;EAChB,8BAA8B;AAChC;;AAEA;EACE,kBAAkB;EAClB,aAAa;EACb,uGAAuG;EACvG,kBAAkB;EAClB,sBAAsB;EACtB,YAAY;EACZ,WAAW;EACX,gBAAgB;AAClB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,aAAa;EACb,eAAe;AACjB","sourcesContent":["\n/**\n * (c) jSuites Javascript Web Components\n *\n * Website: https://jsuites.net\n * Description: Create amazing web based applications.\n *\n * MIT License\n *\n */\n\nsrc/assets/lib/:root {\n  --button-color: #298BA8;\n  --active-color: #007aff;\n  --safe-area-top: env(safe-area-inset-top);\n  --safe-area-bottom: env(safe-area-inset-bottom);\n}\n\ndiv[data-before]:before {\n  content: attr(data-before);\n}\n\n.unselectable {\n  -webkit-touch-callout: none;\n  -webkit-user-select: none;\n  -khtml-user-select: none;\n  -moz-user-select: none;\n  -ms-user-select: none;\n  user-select: none;\n}\n\n.jreadonly {\n  pointer-events: none;\n}\n\n.jdragging {\n  opacity:0.2;\n  filter: alpha(opacity=20);\n}\n\n.jupload.input {\n  position: relative;\n  box-sizing: border-box;\n  background-size: initial;\n  height: 33px;\n  min-height: initial;\n  padding: 6px;\n  padding-right: 30px;\n}\n\n.jupload.input:before {\n  content: \"save\";\n  font-size: 18px;\n  font-family: \"Material Icons\";\n  color: #000;\n  position: absolute;\n  right: 5px;\n}\n\n.jupload img {\n  width: 100%;\n}\n\n.jupload.input img {\n  width: initial;\n  max-width: 100%;\n  height: 100%;\n}\n\n.jupload[data-multiple] {\n  padding: 10px;\n}\n\n.jupload[data-multiple] img {\n  height: 70px;\n  width: 100px;\n  object-fit: cover;\n  margin-right: 5px;\n  margin-bottom: 5px;\n}\n\n.jupload {\n  position: relative;\n  border: 1px dotted #eee;\n  cursor: pointer;\n  box-sizing: border-box;\n  width: 100%;\n  max-height: 100%;\n  min-height: 180px;\n}\n\n.jupload:not(.input):before {\n  content: \"\\e2c3\";\n  font-family: \"Material Icons\";\n  font-size: 90px;\n  color: #eee;\n  width: 100%;\n  height: 100%;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  position: absolute;\n  z-index: -1;\n}\n\n.jupload-item {\n  padding-right: 22px;\n  border-radius: 1px;\n  display: inline-block;\n  position: relative;\n}\n\n.jphoto {\n  position: relative;\n  border: 1px dotted #eee;\n  cursor: pointer;\n  box-sizing: border-box;\n  width: 100%;\n  max-height: 100%;\n  min-height: 180px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n}\n\n.jphoto:empty:before {\n  content: \"\\e2c3\";\n  font-family: \"Material Icons\";\n  font-size: 90px;\n  color: #eee;\n  width: 100%;\n  height: 100%;\n}\n\n.jremove {\n  opacity: 0.2;\n  filter: alpha(opacity=20);\n}\n\n.round img {\n  border-radius: 1000px;\n}\n\n\n\n/** Animations **/\n.fade-in {\n  animation: fade-in 2s forwards;\n}\n\n.fade-out {\n  animation: fade-out 1s forwards;\n}\n\n.slide-left-in {\n  position: relative;\n  animation: slide-left-in 0.4s forwards;\n}\n\n.slide-left-out {\n  position: relative;\n  animation: slide-left-out 0.4s forwards;\n}\n\n.slide-right-in {\n  position: relative;\n  animation: slide-right-in 0.4s forwards;\n}\n\n.slide-right-out {\n  position: relative;\n  animation: slide-right-out 0.4s forwards;\n}\n\n.slide-top-in {\n  position: relative;\n  animation: slide-top-in 0.4s forwards;\n}\n\n.slide-top-out {\n  position: relative;\n  animation: slide-top-out 0.2s forwards;\n}\n\n.slide-bottom-in {\n  position: relative;\n  animation: slide-bottom-in 0.4s forwards;\n}\n\n.slide-bottom-out {\n  position: relative;\n  animation: slide-bottom-out 0.1s forwards;\n}\n\n.spin {\n  animation: spin 2s infinite linear;\n}\n\n/** Fadein and Fadeout **/\n@keyframes fade-in {\n  0% { opacity: 0; }\n  100% { opacity: 100; }\n}\n\n@-webkit-keyframes fade-in {\n  0% { opacity: 0; }\n  100% { opacity: 100; }\n}\n\n@keyframes fade-out {\n  0% { opacity: 100; }\n  100% { opacity: 0; }\n}\n\n@-webkit-keyframes fade-out {\n  0% { opacity: 100; }\n  100% { opacity: 0; }\n}\n\n/** Keyframes Left to Right **/\n@keyframes slide-left-in {\n  0% { left: -100%; }\n  100% { left: 0%; }\n}\n\n@-webkit-keyframes slide-left-in {\n  0% { left: -100%; }\n  100% { left: 0%; }\n}\n\n@keyframes slide-left-out {\n  0% { left: 0%; }\n  100% { left: -100%; }\n}\n\n@-webkit-keyframes slide-left-out {\n  0% { left: 0%; }\n  100% { left: -100%; }\n}\n\n/** Keyframes Right to Left **/\n@keyframes slide-right-in {\n  0% { left: 100%; }\n  100% { left: 0%; }\n}\n\n@-webkit-keyframes slide-right-in\n{\n  0% { left: 100%; }\n  100% { left: 0%; }\n}\n\n@keyframes slide-right-out {\n  0% { left: 0%; }\n  100% { left: 100%; }\n}\n\n@-webkit-keyframes slide-right-out {\n  0% { left: 0%; }\n  100% { left: 100%; }\n}\n\n/** Keyframes Top to Bottom **/\n@keyframes slide-top-in {\n  0% { transform: translateY(-100%); }\n  100% { transform: translateY(0%); }\n}\n\n@-webkit-keyframes slide-top-in {\n  0% { transform: translateY(-100%); }\n  100% { -webkit-transform: translateY(0%); }\n}\n\n@keyframes slide-top-out {\n  0% { transform: translateY(0%); }\n  100% { transform: translateY(-100%); }\n}\n\n@-webkit-keyframes slide-top-out {\n  0% { -webkit-transform: translateY(0%); }\n  100% { -webkit-transform: translateY(-100%); }\n}\n\n/** Keyframes Bottom to Top **/\n@keyframes slide-bottom-in {\n  0% { transform: translateY(100%); }\n  100% { transform: translateY(0%); }\n}\n\n@-webkit-keyframes slide-bottom-in {\n  0% { transform: translateY(100%); }\n  100% { -webkit-transform: translateY(0%); }\n}\n\n@keyframes slide-bottom-out {\n  0% { transform: translateY(0%); }\n  100% { transform: translateY(100%); }\n}\n\n@-webkit-keyframes slide-bottom-out {\n  0% { -webkit-transform: translateY(0%); }\n  100% { -webkit-transform: translateY(100%); }\n}\n\n@-webkit-keyframes spin {\n  from {\n      -webkit-transform:rotate(0deg);\n  }\n  to {\n      -webkit-transform:rotate(359deg);\n  }\n}\n\n@keyframes spin {\n  from {\n      transform:rotate(0deg);\n  }\n  to {\n      transform:rotate(359deg);\n  }\n}\n\n.jcalendar {\n  position:absolute;\n  z-index:9000;\n  display:none;\n  box-sizing:border-box;\n  -webkit-touch-callout: none;\n  -webkit-user-select: none;\n  -khtml-user-select: none;\n  -moz-user-select: none;\n  -ms-user-select: none;\n  user-select: none;\n  -webkit-tap-highlight-color: rgba(0,0,0,0);\n  -webkit-tap-highlight-color: transparent;\n  min-width:280px;\n}\n\n.jcalendar.jcalendar-focus {\n  display:block;\n}\n\n.jcalendar .jcalendar-backdrop {\n  position:fixed;\n  top:0px;\n  left:0px;\n  z-index:9000;\n  min-width:100%;\n  min-height:100%;\n  background-color:rgba(0,0,0,0.5);\n  border:0px;\n  padding:0px;\n  display:none;\n}\n\n.jcalendar .jcalendar-container {\n  position:relative;\n  box-sizing:border-box;\n}\n\n.jcalendar .jcalendar-content {\n  position:absolute;\n  z-index:9001;\n  -webkit-box-shadow: 1px 1px 5px 0px rgba(0,0,0,0.39);\n  -moz-box-shadow: 1px 1px 5px 0px rgba(0,0,0,0.39);\n  box-shadow: 1px 1px 5px 0px rgba(0,0,0,0.39);\n  background-color:#fff;\n}\n\n.jcalendar-header {\n  text-align:center;\n}\n\n.jcalendar-header span {\n  margin-right:4px;\n  font-size:1.1em;\n  font-weight:bold;\n}\n\n.jcalendar-prev {\n  cursor:pointer;\n  background-image:url(\"data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='24' height='24' viewBox='0 0 24 24'%3E%3Cpath d='M15.41 16.59L10.83 12l4.58-4.59L14 6l-6 6 6 6 1.41-1.41z' fill='%23000' /%3E%3Cpath fill='none' d='M0 0h24v24H0V0z'/%3E%3C/svg%3E\");\n  background-position:center;\n  background-repeat:no-repeat;\n}\n\n.jcalendar-next {\n  cursor:pointer;\n  background-image:url(\"data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='24' height='24' viewBox='0 0 24 24'%3E%3Cpath d='M8.59 16.59L13.17 12 8.59 7.41 10 6l6 6-6 6-1.41-1.41z' fill='%23000' /%3E%3Cpath fill='none' d='M0 0h24v24H0V0z'/%3E%3C/svg%3E\");\n  background-position:center;\n  background-repeat:no-repeat;\n}\n\n.jcalendar-weekday {\n  font-weight: 600;\n  background-color: #fcfcfc;\n  padding: 14px;\n}\n\n.jcalendar-table > table {\n  width:100%;\n  background-color:#fff;\n}\n\n.jcalendar-table > table > thead {\n  cursor:pointer;\n}\n\n.jcalendar-table thead td {\n  padding:10px;\n  height:40px;\n}\n\n.jcalendar-table > table > tbody td {\n  box-sizing:border-box;\n  cursor:pointer;\n  padding:9px;\n  font-size:0.9em;\n}\n\n\n.jcalendar-table tfoot td {\n  padding:10px;\n}\n\n.jcalendar-months td, .jcalendar-years td {\n  height:24px;\n}\n\n.jcalendar-input {\n  padding-right:18px;\n  background-image:url(\"data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='16' height='16' viewBox='0 0 24 24' fill='gray'%3E%3Cpath d='M20 3h-1V1h-2v2H7V1H5v2H4c-1.1 0-2 .9-2 2v16c0 1.1.9 2 2 2h16c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2zm0 18H4V8h16v13z'/%3E%3Cpath fill='none' d='M0 0h24v24H0z'/%3E%3C/svg%3E\");\n  background-position:top 50% right 5px;\n  background-repeat:no-repeat;\n  box-sizing: border-box;\n}\n\n.jcalendar-done {\n  -webkit-box-shadow: 1px 1px 5px 0px rgba(0,0,0,0.39);\n  -moz-box-shadow: 1px 1px 5px 0px rgba(0,0,0,0.39);\n  box-shadow: 1px 1px 5px 0px rgba(0,0,0,0.39);\n  background-color:#fff;\n}\n\n.jcalendar-update {\n  border:1px solid #ccc;\n  background-color:#fff;\n  border-radius:4px;\n  padding:5px;\n  width:100%;\n}\n\n.jcalendar-container select {\n  width:55px;\n  display:inline-block;\n  border:0px;\n  padding:4px;\n  text-align:center;\n  font-size:1.1em;\n  user-select:none;\n  margin-right:10px;\n}\n\n.jcalendar-container select:first-child {\n  margin-right:2px;\n}\n\n.jcalendar-selected {\n  background-color:#eee;\n}\n\n.jcalendar-reset, .jcalendar-confirm {\n  text-transform:uppercase;\n  cursor:pointer;\n  color: var(--active-color);\n}\n\n.jcalendar-controls {\n  padding:15px;\n\n  -webkit-box-sizing: border-box;\n  box-sizing: border-box;\n  vertical-align:middle;\n\n  display: -webkit-box;\n  display: -moz-box;\n  display: -ms-flexbox;\n  display: -webkit-flex;\n  display: flex;\n\n  -webkit-flex-flow: row wrap;\n  justify-content: space-between;\n  align-items:center;\n}\n\n.jcalendar-controls div {\n  font-weight:bold;\n}\n\n.jcalendar-fullsize  {\n  position:fixed;\n  width:100%;\n  top:0px;\n  left:0px;\n}\n\n.jcalendar-fullsize .jcalendar-content\n{\n  position:fixed;\n  width:100%;\n  left:0px;\n  bottom:0px;\n}\n\n.jcalendar-focus.jcalendar-fullsize .jcalendar-backdrop {\n  display:block;\n}\n\n.jcalendar-sunday {\n  color: red;\n}\n.jcalendar-disabled {\n  color: #ccc;\n}\n\n.jcalendar-time {\n  display:flex;\n}\n\n\n.jcolor {\n  display: none;\n  outline: none;\n}\n\n.jcolor-input {\n  padding-right:18px;\n  background-image: url(\"data:image/svg+xml,%0A%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 24 24' fill='black' width='18px' height='18px'%3E%3Cpath d='M0 0h24v24H0z' fill='none'/%3E%3Cpath d='M12 3c-4.97 0-9 4.03-9 9s4.03 9 9 9c.83 0 1.5-.67 1.5-1.5 0-.39-.15-.74-.39-1.01-.23-.26-.38-.61-.38-.99 0-.83.67-1.5 1.5-1.5H16c2.76 0 5-2.24 5-5 0-4.42-4.03-8-9-8zm-5.5 9c-.83 0-1.5-.67-1.5-1.5S5.67 9 6.5 9 8 9.67 8 10.5 7.33 12 6.5 12zm3-4C8.67 8 8 7.33 8 6.5S8.67 5 9.5 5s1.5.67 1.5 1.5S10.33 8 9.5 8zm5 0c-.83 0-1.5-.67-1.5-1.5S13.67 5 14.5 5s1.5.67 1.5 1.5S15.33 8 14.5 8zm3 4c-.83 0-1.5-.67-1.5-1.5S16.67 9 17.5 9s1.5.67 1.5 1.5-.67 1.5-1.5 1.5z'/%3E%3C/svg%3E\");\n  background-position:top 50% right 5px;\n  background-repeat:no-repeat;\n  box-sizing: border-box;\n}\n\n.jcolor-content {\n  position: absolute;\n  z-index: 9000;\n  user-select: none;\n  -webkit-font-smoothing: antialiased;\n  font-size: .875rem;\n  letter-spacing: .2px;\n  -webkit-border-radius: 4px;\n  border-radius: 4px;\n  -webkit-box-shadow: 0 8px 10px 1px rgba(0,0,0,0.14), 0 3px 14px 2px rgba(0,0,0,0.12), 0 5px 5px -3px rgba(0,0,0,0.2);\n  box-shadow: 0 8px 10px 1px rgba(0,0,0,0.14), 0 3px 14px 2px rgba(0,0,0,0.12), 0 5px 5px -3px rgba(0,0,0,0.2);\n  background-color:#fff;\n  box-sizing: border-box;\n  min-width: 260px;\n}\n\n.jcolor-controls {\n  display: flex;\n  padding: 10px;\n  border-bottom: 1px solid #eee;\n  margin-bottom: 5px;\n}\n\n.jcolor-controls div {\n  flex: 1;\n  font-size: 1em;\n  color: var(--active-color);\n  text-transform: uppercase;\n  font-weight: bold;\n  box-sizing: border-box;\n}\n\n.jcolor-content table {\n  border-collapse: collapse;\n  box-sizing: border-box;\n}\n\n.jcolor-focus {\n  display:block;\n}\n\n.jcolor table {\n  width:100%;\n  height:100%;\n  min-height: 160px;\n}\n\n.jcolor td {\n  padding: 7px;\n}\n\n.jcolor-selected {\n  background-repeat:no-repeat;\n  background-size: 16px;\n  background-position: center;\n  background-image: url(\"data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='24' height='24' viewBox='0 0 24 24'%3E%3Cpath d='M0 0h24v24H0z' fill='none'/%3E%3Cpath d='M9 16.17L4.83 12l-1.42 1.41L9 19 21 7l-1.41-1.41z' fill='white'/%3E%3C/svg%3E\");\n}\n\n.jcolor-fullscreen {\n  position: fixed;\n  left: 0px;\n  bottom: 0px;\n  width:100%;\n  max-height: 290px;\n  border-radius: 0px;\n  box-sizing: border-box;\n}\n\n.jcolor-fullscreen .jcolor-controls {\n  padding: 15px;\n  -webkit-box-shadow: 1px 0px 1px 0px rgba(0,0,0,0.39);\n  -moz-box-shadow: 1px 0px 1px 0px rgba(0,0,0,0.39);\n  box-shadow: 1px 0px 1px 0px rgba(0,0,0,0.39);\n}\n\n.jcolor-reset {\n  text-align: left;\n}\n\n.jcolor-close {\n  text-align: right;\n}\n\n.jcolor-backdrop {\n  position: fixed;\n  top: 0px;\n  left: 0px;\n  min-width: 100%;\n  min-height: 100%;\n  background-color: rgba(0,0,0,0.5);\n  border: 0px;\n  padding: 0px;\n  z-index: 8000;\n  display: none;\n\n-webkit-touch-callout: none; /* iOS Safari */\n  -webkit-user-select: none; /* Safari */\n   -khtml-user-select: none; /* Konqueror HTML */\n     -moz-user-select: none; /* Firefox */\n      -ms-user-select: none; /* Internet Explorer/Edge */\n          user-select: none; /* Non-prefixed version, currently\n                                supported by Chrome and Opera */\n}\n\n.jcolor-content .jtabs-content {\n  padding: 7px;\n}\n\n.jcolor-grid tr:first-child > td:first-child {\n  border-top-left-radius: 3px;\n}\n\n.jcolor-grid tr:first-child > td:last-child {\n  border-top-right-radius: 3px;\n}\n\n.jcolor-grid tr:last-child > td:first-child {\n  border-bottom-left-radius: 3px;\n}\n\n.jcolor-grid tr:last-child > td:last-child {\n  border-bottom-right-radius: 3px;\n}\n\n.jcolor-hsl {\n  box-sizing: border-box;\n}\n\n.jcolor-hsl > div {\n  height: 100%;\n  position: relative;\n}\n\n.jcolor-hsl canvas {\n  display: block;\n  border-radius: 4px;\n  -webkit-user-drag: none;\n}\n\n.jcolor-point {\n  height: 5px;\n  width: 5px;\n  background-color: #000;\n  position: absolute;\n  top: 50%;\n  left: 50%;\n  transform: translate(-50%, -50%);\n  border-radius: 50%;\n}\n\n.jcolor-sliders {\n  padding: 10px 20px 10px 10px;\n}\n\n.jcolor-sliders input {\n  -webkit-appearance: none;\n\n  height: 12px;\n  width: 80%;\n\n  background: #d3d3d3;\n  opacity: 1;\n\n  border-radius: 30px;\n  outline: none;\n}\n\n.jcolor-sliders-input-subcontainer {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n}\n\n.jcolor-sliders-input-container {\n  margin-top: 4px;\n  line-height: 0.8em;\n  text-align: left;\n}\n\n.jcolor-sliders-input-container > label {\n  font-size: 10px;\n  text-transform: uppercase;\n  color: #bbbbbd;\n}\n\n.jcolor-sliders-input-subcontainer > input {\n  border: 0px;\n  padding: 1px;\n}\n\n.jcolor-sliders-input-container input::-webkit-slider-thumb {\n  -webkit-appearance: none;\n  height: 12px;\n  width: 12px;\n  border-radius: 50%;\n  background: #000;\n  border: 2px solid #fff;\n  cursor: pointer;\n}\n\n.jcolor-sliders-input-container input::-moz-range-thumb {\n  -webkit-appearance: none;\n  height: 12px;\n  width: 12px;\n  border-radius: 50%;\n  background: #000;\n  border: 2px solid #fff;\n  cursor: pointer;\n}\n\n.jcolor-sliders-final-color {\n  padding: 6px;\n  user-select: all;\n  margin-top: 10px;\n  text-align: center;\n}\n\n.jcolor-sliders-final-color > div:nth-child(2) {\n  width: 71px;\n  text-transform: uppercase;\n}\n\n.jcolor .jtabs .jtabs-headers-container .jtabs-controls {\n  display: none !important;\n}\n\n.jcolor .jtabs .jtabs-headers-container {\n  display: flex !important;\n  justify-content: center;\n  padding: 4px;\n}\n\n.jcolor .jtabs-headers > div:not(.jtabs-border) {\n  padding: 2px !important;\n  padding-left: 15px !important;\n  padding-right: 15px !important;\n  font-size: 0.8em;\n}\n\n.jcontextmenu {\n  position:fixed;\n  z-index:10000;\n  background:#fff;\n  color: #555;\n  font-size: 11px;\n  -webkit-user-select: none;\n  -moz-user-select: none;\n  user-select: none;\n  -webkit-box-shadow: 2px 2px 2px 0px rgba(143, 144, 145, 1);\n  -moz-box-shadow: 2px 2px 2px 0px rgba(143, 144, 145, 1);\n  box-shadow: 2px 2px 2px 0px rgba(143, 144, 145, 1);\n  border: 1px solid #C6C6C6;\n  padding: 0px;\n  padding-top:4px;\n  padding-bottom:4px;\n  margin:0px;\n  outline:none;\n  display:none;\n}\n\n.jcontextmenu.jcontextmenu-focus {\n  display:inline-block;\n}\n\n.jcontextmenu > div {\n  box-sizing: border-box;\n  display: flex;\n  padding: 8px 8px 8px 32px;\n  width: 250px;\n  position: relative;\n  cursor: default;\n  font-size: 11px;\n  font-family:sans-serif;\n  text-align: left;\n}\n\n.jcontextmenu > div::before {\n  content: attr(data-icon);\n  font-family: 'Material Icons' !important;\n  font-weight: normal;\n  font-style: normal;\n  font-size: 16px;\n  line-height: 1;\n  letter-spacing: normal;\n  text-transform: none;\n  display: inline-block;\n  white-space: nowrap;\n  word-wrap: normal;\n  direction: ltr;\n  -webkit-font-feature-settings: 'liga';\n  -webkit-font-smoothing: antialiased;\n  position: absolute;\n  left: 9px;\n}\n\n.jcontextmenu > div.header {\n  display: none;\n}\n\n.jcontextmenu > div a {\n  color: #555;\n  text-decoration: none;\n  flex: 1;\n}\n\n.jcontextmenu > div span {\n  margin-right:10px;\n}\n\n.jcontextmenu .jcontextmenu-disabled a {\n  color: #ccc;\n}\n\n.jcontextmenu > div:hover {\n  background: #ebebeb;\n}\n\n.jcontextmenu hr {\n  border: 1px solid #e9e9e9;\n  border-bottom: 0;\n  margin-top:5px;\n  margin-bottom:5px;\n}\n\n.jcontextmenu > hr:hover {\n  background: transparent;\n}\n\n.jcontextmenu .jcontextmenu {\n  top: 4px;\n  left: 99%;\n  opacity: 0;\n  position: absolute;\n}\n\n.jcontextmenu > div:hover > .jcontextmenu {\n  display: block;\n  opacity: 1;\n  -webkit-transform: translate(0, 0) scale(1);\n  transform: translate(0, 0) scale(1);\n  pointer-events: auto;\n}\n\n@media only screen and (max-width: 420px) {\n  .jcontextmenu {\n      top: initial !important;\n      left: 0px !important;\n      bottom: 0px !important;\n      width: 100vw;\n      height: 260px;\n      overflow: scroll;\n      animation: slide-bottom-in 0.4s forwards;\n      padding-top: 0px;\n  }\n  .jcontextmenu div {\n      width: 100%;\n      text-align: center;\n      border-bottom: 1px solid #ccc;\n      padding: 15px;\n  }\n  .jcontextmenu > div.header {\n      background-color: lightgray;\n      padding: 5px;\n      top: 0px;\n      position: sticky;\n      z-index: 2;\n  }\n  .jcontextmenu > div.header > a.title {\n      text-align: left;\n  }\n\n  .jcontextmenu > div.header > a.close {\n      text-align: right;\n  }\n\n  .jcontextmenu > div::before {\n      content: attr(data-icon);\n      font-family: 'Material Icons' !important;\n      font-weight: normal;\n      font-style: normal;\n      font-size: 16px;\n      line-height: 1;\n      letter-spacing: normal;\n      text-transform: none;\n      display: inline-block;\n      white-space: nowrap;\n      word-wrap: normal;\n      direction: ltr;\n      -webkit-font-feature-settings: 'liga';\n      -webkit-font-smoothing: antialiased;\n      position: absolute;\n      left: 9px;\n  }\n  .jcontextmenu a {\n      font-size: 1.4em;\n      text-transform: uppercase;\n  }\n  .jcontextmenu span {\n      display: none;\n  }\n  .jcontextmenu span {\n      display: none;\n  }\n  .jcontextmenu hr {\n      display: none;\n  }\n}\n\n\n.jdropdown {\n  cursor:pointer;\n  -webkit-touch-callout: none;\n  -webkit-user-select: none;\n  -khtml-user-select: none;\n  -moz-user-select: none;\n  -ms-user-select: none;\n  user-select: none;\n  box-sizing: border-box;\n  background:#fff;\n  -webkit-tap-highlight-color: transparent;\n  display: inline-block;\n}\n\n.jdropdown-header::placeholder {\n  color:#000;\n}\n\n.jdropdown-backdrop {\n  position:fixed;\n  top:0px;\n  left:0px;\n  min-width:100%;\n  min-height:100%;\n  background-color:rgba(0,0,0,0.5);\n  border:0px;\n  padding:0px;\n  z-index:8000;\n  display:none;\n}\n\n.jdropdown[disabled] {\n  opacity: 0.5;\n  pointer-events: none;\n}\n\n.jdropdown-focus {\n  position:relative;\n}\n\n.jdropdown-focus .jdropdown-container {\n  transform: translate3d(0,0,0);\n}\n\n.jdropdown-default.jdropdown-focus .jdropdown-header {\n  outline:auto 5px -webkit-focus-ring-color;\n}\n\n.jdropdown-default.jdropdown-focus .jdropdown-header.jdropdown-add {\n  background-image: url(\"data:image/svg+xml,%0A%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 24 24' fill='gray' width='24px' height='24px'%3E%3Cpath d='M0 0h24v24H0z' fill='none'/%3E%3Cpath d='M19 3H5c-1.11 0-2 .9-2 2v14c0 1.1.89 2 2 2h14c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2zm-2 10h-4v4h-2v-4H7v-2h4V7h2v4h4v2z'/%3E%3C/svg%3E\");\n}\n\n.jdropdown-container-header\n{\n  padding:0px;\n  margin:0px;\n  position:relative;\n}\n\n.jdropdown-header\n{\n  width:100%;\n  appearance: none;\n  background-repeat: no-repeat;\n  background-position:top 50% right 5px;\n  background-image: url(\"data:image/svg+xml,%0A%3Csvg xmlns='http://www.w3.org/2000/svg' width='24' height='24' viewBox='0 0 24 24'%3E%3Cpath fill='none' d='M0 0h24v24H0V0z'/%3E%3Cpath d='M7 10l5 5 5-5H7z' fill='gray'/%3E%3C/svg%3E\");\n  text-overflow: ellipsis;\n  cursor:pointer;\n  box-sizing: border-box;\n  -webkit-appearance: none;\n  -moz-appearance: none;\n  padding-right:30px !important;\n}\n\n.jdropdown-insert-button\n{\n  font-size: 1.4em;\n  text-transform: uppercase;\n  position:absolute;\n  right: 30px;\n  top: 4px;\n  display:none;\n}\n\n.jdropdown-container\n{\n  min-width: inherit;\n  transform: translate3d(-10000px,0,0);\n  position:absolute;\n  z-index:9001;\n}\n\n.jdropdown-close\n{\n  display:none;\n  font-size:1em;\n  color: var(--active-color);\n  text-transform:uppercase;\n  text-align:right;\n  padding:15px;\n  font-weight:bold;\n}\n\n.jdropdown-content\n{\n  min-width:inherit;\n  margin:0px;\n  box-sizing:border-box;\n}\n\n.jdropdown-content:empty\n{\n}\n\n.jdropdown-item\n{\n  white-space: nowrap;\n  text-align: left;\n  text-overflow: ellipsis;\n  overflow-x: hidden;\n  color: #000;\n  display: flex;\n  align-items: center;\n}\n\n.jdropdown-description\n{\n  text-overflow: ellipsis;\n  overflow: hidden;\n  line-height: 1.5em;\n}\n\n.jdropdown-image\n{\n  margin-right:10px;\n  width: 32px;\n  height: 32px;\n  border-radius:20px;\n}\n\n.jdropdown-image-small\n{\n  width:24px;\n  height:24px;\n}\n\n.jdropdown-icon\n{\n  margin-right:10px;\n  font-size: 30px;\n  margin-left: -5px;\n}\n\n.jdropdown-icon-small\n{\n  font-size: 24px;\n  margin-left: 0px;\n}\n\n.jdropdown-title\n{\n  font-size: 0.7em;\n  text-overflow: ellipsis;\n  overflow-x: hidden;\n  display: block;\n}\n\n/** Default visual **/\n\n.jdropdown-default .jdropdown-header\n{\n  border:1px solid #ccc;\n  padding:5px;\n  padding-left:10px;\n  padding-right:16px;\n}\n\n.jdropdown-default .jdropdown-container\n{\n  background-color:#fff;\n}\n\n.jdropdown-default.jdropdown-focus.jdropdown-insert .jdropdown-header {\n  padding-right:50px;\n}\n\n.jdropdown-default.jdropdown-focus.jdropdown-insert .jdropdown-insert-button {\n  display:block;\n}\n\n.jdropdown-default .jdropdown-content\n{\n  min-width:inherit;\n  border:1px solid #8fb1e3;\n  margin:0px;\n  background-color:#fff;\n  box-sizing:border-box;\n  min-height:10px;\n  max-height:215px;\n  overflow-y:auto;\n}\n\n.jdropdown-default .jdropdown-item\n{\n  padding:4px;\n  padding-left:8px;\n  padding-right:40px;\n}\n\n.jdropdown-default .jdropdown-item:hover\n{\n  background-color:#1f93ff;\n  color:#fff;\n}\n\n.jdropdown-default .jdropdown-cursor\n{\n  background-color:#eee;\n}\n\n.jdropdown-default .jdropdown-selected\n{\n  background-image: url('data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSIyNCIgaGVpZ2h0PSIyNCIgdmlld0JveD0iMCAwIDI0IDI0Ij48cGF0aCBkPSJNMCAwaDI0djI0SDB6IiBmaWxsPSJub25lIiAvPjxwYXRoIGQ9Ik05IDE2LjE3TDQuODMgMTJsLTEuNDIgMS40MUw5IDE5IDIxIDdsLTEuNDEtMS40MXoiIGZpbGw9IndoaXRlIiAvPjwvc3ZnPgo=');\n  background-repeat:no-repeat;\n  background-position:top 50% right 5px;\n  background-color:#1f93ff;\n  color:#fff;\n}\n\n.jdropdown-default .jdropdown-group {\n  margin-top:5px;\n}\n\n.jdropdown-default .jdropdown-group .jdropdown-item {\n  padding-left:16px;\n}\n\n.jdropdown-default .jdropdown-group-name {\n  padding-left: 8px;\n  font-weight: bold;\n  text-align: left;\n}\n\n.jdropdown-default .jdropdown-reset_ {\n  content:'x';\n  position:absolute;\n  top:0;\n  right:0;\n  margin:5px;\n  margin-right:10px;\n  font-size:12px;\n  width:12px;\n  cursor:pointer;\n  text-shadow: 0px 0px 5px #fff;\n  display:none;\n  line-height: 1.8em;\n}\n\n.jdropdown-default.jdropdown-focus .jdropdown-reset_ {\n  display:block;\n}\n\n/** Default render for mobile **/\n\n.jdropdown-picker.jdropdown-focus .jdropdown-backdrop {\n  display:block;\n}\n\n.jdropdown-picker .jdropdown-header {\n  outline: none;\n}\n\n.jdropdown-picker .jdropdown-container\n{\n  position:fixed;\n  bottom:0px;\n  left:0px;\n  border-bottom:1px solid #e6e6e8;\n  width:100%;\n  background-color:#fff;\n  box-sizing: border-box;\n}\n\n.jdropdown-picker .jdropdown-close\n{\n  -webkit-box-shadow: 0px -1px 5px 0px rgba(0,0,0,0.39);\n  -moz-box-shadow: 0px -1px 5px 0px rgba(0,0,0,0.39);\n  box-shadow: 0px -1px 5px 0px rgba(0,0,0,0.39);\n  background-color:#fff;\n  display:block;\n}\n\n.jdropdown-picker .jdropdown-content\n{\n  overflow-y:scroll;\n  height:280px;\n  background-color:#fafafa;\n  border-top:1px solid #e6e6e8;\n}\n\n.jdropdown-picker .jdropdown-group-name\n{\n  font-size: 1em;\n  text-transform: uppercase;\n  padding-top:10px;\n  padding-bottom:10px;\n  display: block;\n  border-bottom: 1px solid #e6e6e8;\n  padding-left:20px;\n  padding-right:20px;\n  text-align:center;\n  font-weight:bold;\n}\n\n.jdropdown-picker .jdropdown-item\n{\n  font-size: 1em;\n  text-transform: uppercase;\n  padding-top:10px;\n  padding-bottom:10px;\n  border-bottom: 1px solid #e6e6e8;\n  padding-left:20px;\n  padding-right:20px;\n}\n\n.jdropdown-picker .jdropdown-selected\n{\n  background-image: url('data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSIyNCIgaGVpZ2h0PSIyNCIgdmlld0JveD0iMCAwIDI0IDI0Ij48cGF0aCBkPSJNMCAwaDI0djI0SDB6IiBmaWxsPSJub25lIiAvPjxwYXRoIGQ9Ik05IDE2LjE3TDQuODMgMTJsLTEuNDIgMS40MUw5IDE5IDIxIDdsLTEuNDEtMS40MXoiIGZpbGw9IndoaXRlIiAvPjwvc3ZnPgo=');\n  background-repeat:no-repeat;\n  background-position:top 50% right 15px;\n  background-color:#1f93ff;\n  color:#fff;\n}\n\n.jdropdown-picker .jdropdown-cursor\n{\n  background-color:#1f93ff;\n  color:#fff;\n}\n\n/** Default render for mobile searchbar **/\n\n.jdropdown-searchbar.jdropdown-focus\n{\n  position:fixed;\n  top:0px !important;\n  left:0px !important;\n  width:100% !important;\n  height:100% !important;\n  background-color:#fafafa;\n  padding:0px;\n  z-index:9001;\n  overflow-y:scroll;\n  will-change: scroll-position;\n  -webkit-overflow-scrolling: touch;\n}\n\n.jdropdown-searchbar.jdropdown-focus .jdropdown-container-header\n{\n  position: fixed;\n  top: 0px;\n  left: 0px;\n  z-index: 9002;\n  padding:10px;\n  background-color:#fff;\n  box-shadow: 0 1px 2px rgba(0,0,0,.1);\n  max-height: 24px;\n  width: 100%;\n}\n\n.jdropdown-searchbar.jdropdown-focus .jdropdown-header\n{\n  border: 0px;\n  background-repeat: no-repeat;\n  background-position-x: 0%;\n  background-position-y: 40%;\n  background-image: url(data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSIyNCIgaGVpZ2h0PSIyNCIgdmlld0JveD0iMCAwIDI0IDI0Ij48cGF0aCBkPSJNMTUuNSAxNGgtLjc5bC0uMjgtLjI3QzE1LjQxIDEyLjU5IDE2IDExLjExIDE2IDkuNSAxNiA1LjkxIDEzLjA5IDMgOS41IDNTMyA1LjkxIDMgOS41IDUuOTEgMTYgOS41IDE2YzEuNjEgMCAzLjA5LS41OSA0LjIzLTEuNTdsLjI3LjI4di43OWw1IDQuOTlMMjAuNDkgMTlsLTQuOTktNXptLTYgMEM3LjAxIDE0IDUgMTEuOTkgNSA5LjVTNy4wMSA1IDkuNSA1IDE0IDcuMDEgMTQgOS41IDExLjk5IDE0IDkuNSAxNHoiIGZpbGw9IiNlNmU2ZTgiLz48cGF0aCBkPSJNMCAwaDI0djI0SDB6IiBmaWxsPSJub25lIi8+PC9zdmc+);\n  padding-left: 30px !important;\n  padding-right: 60px !important;\n}\n\n.jdropdown-searchbar.jdropdown-focus .jdropdown-close\n{\n  display:block;\n}\n\n.jdropdown-searchbar .jdropdown-header {\n  outline: none;\n}\n\n.jdropdown-searchbar .jdropdown-container\n{\n  margin-top: 40px;\n  width:100%;\n}\n\n.jdropdown-searchbar .jdropdown-close\n{\n  position:fixed;\n  top:0px;\n  right:0px;\n}\n\n.jdropdown-searchbar .jdropdown-content\n{\n  margin-top:10px;\n}\n\n.jdropdown-searchbar .jdropdown-group\n{\n  margin-top:10px;\n  margin-bottom:15px;\n  background-color:#fff;\n}\n\n.jdropdown-searchbar .jdropdown-group-name\n{\n  border-top: 1px solid #e6e6e8;\n  border-bottom: 1px solid #e6e6e8;\n  padding:10px;\n  padding-left:12px;\n  font-weight:bold;\n}\n\n.jdropdown-searchbar .jdropdown-group-arrow\n{\n  float:right;\n  width:24px;\n  height:24px;\n  background-repeat:no-repeat;\n}\n\n.jdropdown-searchbar .jdropdown-group-arrow-down\n{\n  background-image: url(data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSIyNCIgaGVpZ2h0PSIyNCIgdmlld0JveD0iMCAwIDI0IDI0Ij48cGF0aCBkPSJNNy40MSA4LjU5TDEyIDEzLjE3bDQuNTktNC41OEwxOCAxMGwtNiA2LTYtNiAxLjQxLTEuNDF6Ii8+PHBhdGggZmlsbD0ibm9uZSIgZD0iTTAgMGgyNHYyNEgwVjB6Ii8+PC9zdmc+);\n}\n\n.jdropdown-searchbar .jdropdown-group-arrow-up\n{\n  background-image: url(data:image/svg+xml;base64,CjxzdmcgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIiB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIHZpZXdCb3g9IjAgMCAyNCAyNCI+PHBhdGggZD0iTTcuNDEgMTUuNDFMMTIgMTAuODNsNC41OSA0LjU4TDE4IDE0bC02LTYtNiA2eiIvPjxwYXRoIGQ9Ik0wIDBoMjR2MjRIMHoiIGZpbGw9Im5vbmUiLz48L3N2Zz4=);\n}\n\n.jdropdown-searchbar .jdropdown-item\n{\n  padding-top:10px;\n  padding-bottom:10px;\n  border-bottom: 1px solid #e6e6e8;\n  padding-left:15px;\n  padding-right:40px;\n  background-color:#fff;\n  font-size:0.9em;\n}\n\n.jdropdown-searchbar .jdropdown-description {\n  text-overflow: ellipsis;\n  overflow: hidden;\n  max-width: calc(100% - 20px);\n}\n\n.jdropdown-searchbar .jdropdown-content > .jdropdown-item:first-child\n{\n  border-top: 1px solid #e6e6e8;\n}\n\n.jdropdown-searchbar .jdropdown-selected\n{\n  background-image: url('data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSIyNCIgaGVpZ2h0PSIyNCIgdmlld0JveD0iMCAwIDI0IDI0Ij48cGF0aCBkPSJNMCAwaDI0djI0SDB6IiBmaWxsPSJub25lIi8+PHBhdGggZD0iTTkgMTYuMTdMNC44MyAxMmwtMS40MiAxLjQxTDkgMTkgMjEgN2wtMS40MS0xLjQxeiIgZmlsbD0iIzAwN2FmZiIvPjwvc3ZnPg==');\n  background-repeat:no-repeat;\n  background-position:top 50% right 15px;\n}\n\n/** List render **/\n\n.jdropdown-list\n{\n}\n\n.jdropdown-list .jdropdown-container\n{\n  display:block;\n}\n\n.jdropdown-list .jdropdown-header\n{\n  display:none;\n}\n\n.jdropdown-list .jdropdown-group\n{\n  background-color:#fff;\n}\n\n.jdropdown-list .jdropdown-group-name\n{\n  border-bottom: 1px solid #e6e6e8;\n  padding-top:10px;\n  padding-bottom:10px;\n  font-weight:bold;\n}\n\n.jdropdown-list .jdropdown-item\n{\n  padding-top:10px;\n  padding-bottom:10px;\n  border-bottom: 1px solid #e6e6e8;\n  padding-left:10px;\n  padding-right:40px;\n  background-color:#fff;\n}\n\n.jdropdown-list .jdropdown-selected\n{\n  background-image: url('data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSIyNCIgaGVpZ2h0PSIyNCIgdmlld0JveD0iMCAwIDI0IDI0Ij48cGF0aCBkPSJNMCAwaDI0djI0SDB6IiBmaWxsPSJub25lIi8+PHBhdGggZD0iTTkgMTYuMTdMNC44MyAxMmwtMS40MiAxLjQxTDkgMTkgMjEgN2wtMS40MS0xLjQxeiIgZmlsbD0iIzAwN2FmZiIvPjwvc3ZnPg==');\n  background-repeat:no-repeat;\n  background-position:top 50% right 10px;\n}\n\n@media only screen and (max-width : 800px)\n{\n  .jdropdown-list {\n      width:100% !important;\n      border:0px;\n      padding:0px;\n  }\n\n  .jdropdown-list .jdropdown-container {\n      min-width:100%;\n  }\n\n  .jdropdown-searchbar.jdropdown-focus .jdropdown-description {\n      text-transform: uppercase;\n  }\n}\n\n.app .jdropdown-item {\n  text-transform:uppercase;\n}\n\n.jdropdown-create-container {\n  margin: 10px;\n  border: 1px solid #ccc;\n  border-radius: 2px;\n  padding: 6px;\n}\n\n.jdropdown-color {\n  background-color: #fff;\n  border: 1px solid transparent;\n  border-radius: 12px;\n  width: 12px;\n  height: 12px;\n  margin-right: 6px;\n}\n\n.jdropdown-item[data-disabled] {\n  opacity: 0.5;\n  pointer-events: none;\n}\n\n.jeditor-container {\n  border:1px solid #ccc;\n  box-sizing: border-box;\n}\n\n.jeditor-dragging {\n   border:1px dashed #000;\n}\n\n.jeditor-container.jeditor-padding {\n  padding:10px;\n}\n\n.jeditor {\n  outline:none;\n  word-break: break-word;\n\n}\n\n.jeditor[data-placeholder]:empty:before {\n  content: attr(data-placeholder);\n  color: lightgray;\n}\n\n.jeditor-container.jeditor-padding .jeditor {\n  min-height:100px;\n  margin-bottom:10px;\n  padding:10px;\n}\n\n/** Snippet **/\n\n.jsnippet {\n  margin-top:15px;\n  cursor:pointer;\n  border: 1px solid #ccc;\n  position:relative;\n}\n\n.jsnippet:focus {\n  outline: none;\n}\n\n.jsnippet img {\n  width:100%;\n}\n\n.jsnippet .jsnippet-title {\n  padding:15px;\n  font-size:1.4em;\n}\n\n.jsnippet .jsnippet-description {\n  padding-left:15px;\n  padding-right:15px;\n  font-size:1em;\n}\n\n.jsnippet .jsnippet-host {\n  padding:15px;\n  text-transform:uppercase;\n  font-size:0.8em;\n  color:#777;\n  text-align:right;\n}\n\n.jsnippet .jsnippet-url {\n  display:none;\n}\n\n.jeditor .jsnippet:after {\n  content: 'close';\n  font-family: 'Material icons';\n  font-size: 24px;\n  width: 24px;\n  height: 24px;\n  line-height: 24px;\n  cursor: pointer;\n  text-shadow: 0px 0px 2px #fff;\n  position: absolute;\n  top: 12px;\n  right: 12px;\n}\n\n.jsnippet * {\n  -webkit-user-select: none;\n  -khtml-user-select: none;\n  -moz-user-select: none;\n  -o-user-select: none;\n  user-select: none;\n\n  -webkit-user-drag: none;\n  -khtml-user-drag: none;\n  -moz-user-drag: none;\n  -o-user-drag: none;\n}\n\n.jeditor img {\n  border:2px solid transparent;\n  box-sizing: border-box;\n}\n\n.jeditor img.resizing {\n  -webkit-user-select: none;\n  -khtml-user-select: none;\n  -moz-user-select: none;\n  -o-user-select: none;\n  user-select: none;\n\n  -webkit-user-drag: none;\n  -khtml-user-drag: none;\n  -moz-user-drag: none;\n  -o-user-drag: none;\n}\n\n.jeditor img:focus {\n  border:2px solid #0096FD;\n  outline: #0096FD;\n}\n\n.jeditor .pdf {\n  background-image: url(\"data:image/svg+xml,%3Csvg version='1.1' id='Layer_1' xmlns='http://www.w3.org/2000/svg' xmlns:xlink='http://www.w3.org/1999/xlink' x='0px' y='0px' viewBox='0 0 512 512' style='enable-background:new 0 0 512 512;' xml:space='preserve'%3E%3Cpath style='fill:%23C30B15;' d='M511.344,274.266C511.77,268.231,512,262.143,512,256C512,114.615,397.385,0,256,0S0,114.615,0,256 c0,117.769,79.53,216.949,187.809,246.801L511.344,274.266z'/%3E%3Cpath style='fill:%2385080E;' d='M511.344,274.266L314.991,77.913L119.096,434.087l68.714,68.714C209.522,508.787,232.385,512,256,512 C391.243,512,501.976,407.125,511.344,274.266z'/%3E%3Cpolygon style='fill:%23FFFFFF;' points='278.328,333.913 255.711,77.913 119.096,77.913 119.096,311.652 '/%3E%3Cpolygon style='fill:%23E8E6E6;' points='392.904,311.652 392.904,155.826 337.252,133.565 314.991,77.913 255.711,77.913 256.067,333.913 '/%3E%3Cpolygon style='fill:%23FFFFFF;' points='314.991,155.826 314.991,77.913 392.904,155.826 '/%3E%3Crect x='119.096' y='311.652' style='fill:%23FC0F1A;' width='273.809' height='122.435'/%3E%3Cg%3E%3Cpath style='fill:%23FFFFFF;' d='M204.871,346.387c13.547,0,21.341,6.659,21.341,18.465c0,12.412-7.795,19.601-21.341,19.601h-9.611 v14.909h-13.471v-52.975L204.871,346.387L204.871,346.387z M195.26,373.858h8.93c5.904,0,9.308-2.952,9.308-8.552 c0-5.525-3.406-8.324-9.308-8.324h-8.93V373.858z'/%3E%3Cpath style='fill:%23FFFFFF;' d='M257.928,346.387c16.649,0,28.152,10.746,28.152,26.487c0,15.666-11.655,26.488-28.683,26.488 h-22.25v-52.975H257.928z M248.619,388.615h9.611c8.249,0,14.151-6.357,14.151-15.665c0-9.384-6.205-15.817-14.757-15.817h-9.006 V388.615z'/%3E%3Cpath style='fill:%23FFFFFF;' d='M308.563,356.982v12.26h23.763v10.596h-23.763v19.525h-13.471v-52.975h39.277v10.595h-25.806 V356.982z'/%3E%3C/g%3E%3C/svg%3E%0A\");\n  background-repeat: no-repeat;\n  background-size: cover;\n  width:60px;\n  height:60px;\n}\n\n.jeditor-toolbar {\n  width: fit-content;\n  max-width: 100%;\n  box-sizing: border-box;\n}\n\n.jloading {\n  position:fixed;\n  z-index:10001;\n  width:100%;\n  left:0;\n  right:0;\n  top:0;\n  bottom:0;\n  background-color: rgba(0,0,0,0.7);\n}\n\n.jloading::after {\n  content:'';\n  display:block;\n  margin:0 auto;\n  margin-top:50vh;\n  width:40px;\n  height:40px;\n  border-style:solid;\n  border-color:white;\n  border-top-color:transparent;\n  border-width:4px;\n  border-radius:50%;\n  -webkit-animation: spin .8s linear infinite;\n  animation: spin .8s linear infinite;\n}\n\n.jloading.spin {\n  background-color:transparent;\n}\n\n.jloading.spin::after {\n  margin:0 auto;\n  margin-top:80px;\n  border-color:#aaa;\n  border-top-color:transparent;\n}\n\n\n.jmodal {\n  position:fixed;\n  top:50%;\n  left:50%;\n  width:60%;\n  height:60%;\n  -webkit-box-shadow: 0 2px 10px rgba(0,0,0,.2);\n  -moz-box-shadow: 0 2px 10px rgba(0,0,0,.2);\n  border:1px solid #ccc;\n  background-color:#fff;\n  transform: translate(-50%, -50%);\n  box-sizing: border-box;\n  padding-top:50px !important;\n  z-index:9002;\n  border-radius: 8px;\n}\n\n.jmodal:before {\n  position:absolute;\n  top:0;\n  left:0;\n  width:100%;\n  content:attr(title);\n  padding:15px;\n  box-sizing: border-box;\n  font-size:1.2em;\n  box-shadow: 1px 1px 3px rgba(0,0,0,.2);\n  background-color: #fff;\n  border-radius: 8px 8px 0px 0px;\n}\n\n.jmodal_content {\n  padding:20px;\n  overflow-y:auto;\n  max-height:100%;\n  box-sizing: border-box;\n  height: -webkit-fill-available;\n}\n.jmodal.no-title {\n  padding-top: initial !important;\n}\n\n.jmodal.no-title:before {\n  display:none;\n}\n\n.jmodal:after {\n  content:'';\n  background-image: url(\"data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='24' height='24' viewBox='0 0 24 24'%3E%3Cpath d='M19 6.41L17.59 5 12 10.59 6.41 5 5 6.41 10.59 12 5 17.59 6.41 19 12 13.41 17.59 19 19 17.59 13.41 12z'/%3E%3Cpath d='M0 0h24v24H0z' fill='none'/%3E%3C/svg%3E\");\n  position:absolute;\n  top:0;\n  right:0;\n  margin:14px;\n  font-size:24px;\n  width:24px;\n  height:24px;\n  cursor:pointer;\n  text-shadow: 0px 0px 5px #fff;\n}\n\n.jmodal_fullscreen {\n  width: 100% !important;\n  height: 100% !important;\n  top: 0px;\n  left: 0px;\n  transform: none;\n  border: 0px;\n  border-radius: 0px;\n}\n\n.jmodal_backdrop {\n  position: fixed;\n  top: 0px;\n  left: 0px;\n  min-width: 100%;\n  min-height: 100%;\n  background-color: rgba(0,0,0,0.5);\n  border: 0px;\n  padding: 0px;\n  z-index: 8000;\n  display: none;\n\n-webkit-touch-callout: none; /* iOS Safari */\n  -webkit-user-select: none; /* Safari */\n   -khtml-user-select: none; /* Konqueror HTML */\n     -moz-user-select: none; /* Firefox */\n      -ms-user-select: none; /* Internet Explorer/Edge */\n          user-select: none; /* Non-prefixed version, currently\n                                supported by Chrome and Opera */\n}\n\n\n.jnotification {\n  position: fixed;\n  z-index: 10000;\n  -webkit-box-sizing: border-box;\n  box-sizing: border-box;\n  padding: 10px;\n  bottom: 0px;\n}\n\n.jnotification-container {\n  -webkit-box-shadow: 0px 2px 15px -5px rgba(0, 0, 0, 0.7);\n  box-shadow: 0px 2px 15px -5px rgba(0, 0, 0, 0.7);\n  padding: 12px;\n  border-radius: 8px;\n\n  background-color: #000;\n  background: rgba(92,92,92,1);\n  background: linear-gradient(0deg, rgba(92,92,92,1) 0%, rgba(77,77,77,1) 100%);\n  color: #fff;\n  width: 320px;\n  margin: 30px;\n  padding: 20px;\n}\n\n.jnotification-close {\n  content: '';\n  background-image: url(\"data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='20' height='20' viewBox='0 0 24 24' fill='white'%3E%3Cpath d='M19 6.41L17.59 5 12 10.59 6.41 5 5 6.41 10.59 12 5 17.59 6.41 19 12 13.41 17.59 19 19 17.59 13.41 12z'/%3E%3Cpath d='M0 0h24v24H0z' fill='none'/%3E%3C/svg%3E\");\n  font-size: 20px;\n  width: 20px;\n  height: 20px;\n  cursor: pointer;\n}\n\n.jnotification-title {\n  font-weight: bold;\n}\n\n.jnotification-header {\n  display: flex;\n  padding-bottom: 5px;\n}\n\n.jnotification-header:empty {\n  display: none;\n}\n\n.jnotification-image {\n  margin-right: 5px;\n}\n\n.jnotification-image:empty {\n  display: none;\n}\n\n.jnotification-image img {\n  width: 24px;\n}\n\n.jnotification-name {\n  text-transform: uppercase;\n  font-size: 0.9em;\n  flex: 1;\n  letter-spacing: 0.1em;\n}\n\n.jnotification-error .jnotification-container {\n  background: rgb(182,38,6);\n  background: linear-gradient(0deg, rgba(170,41,13,1) 0%, rgba(149,11,11,1) 100%);\n}\n\n@media (max-width: 800px) {\n  .jnotification {\n      top: calc(0px + var(--safe-area-top));\n      width: 100%;\n  }\n  .jnotification-container {\n      background: rgba(255,255,255,0.95);\n      border: 1px solid #eee;\n      color: #444;\n      margin: 0px;\n      width: initial;\n  }\n  .jnotification-error .jnotification-container {\n      background: rgba(255,255,255,0.95);\n      color: #790909;\n  }\n  .jnotification-close {\n      background-image: url(\"data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='20' height='20' viewBox='0 0 24 24' fill='black'%3E%3Cpath d='M19 6.41L17.59 5 12 10.59 6.41 5 5 6.41 10.59 12 5 17.59 6.41 19 12 13.41 17.59 19 19 17.59 13.41 12z'/%3E%3Cpath d='M0 0h24v24H0z' fill='none'/%3E%3C/svg%3E\");\n  }\n}\n\n.jnotification-header {\n  display: -webkit-box;\n  display: -webkit-flex;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-pack: start;\n  -webkit-justify-content: flex-start;\n  -ms-flex-pack: start;\n  justify-content: flex-start;\n  -webkit-box-align: center;\n  -webkit-align-items: center;\n  -ms-flex-align: center;\n  align-items: center;\n}\n\n.jpicker {\n  cursor: pointer;\n  white-space: nowrap;\n  display: inline-flex;\n  -webkit-user-select: none;\n  -moz-user-select: none;\n  -ms-user-select: none;\n  user-select: none;\n  outline: none;\n  position: relative;\n}\n\n.jpicker-header {\n  background-repeat: no-repeat;\n  background-position: top 50% right 5px;\n  background-image: url(\"data:image/svg+xml,%0A%3Csvg xmlns='http://www.w3.org/2000/svg' width='24' height='24' viewBox='0 0 24 24'%3E%3Cpath fill='none' d='M0 0h24v24H0V0z'/%3E%3Cpath d='M7 10l5 5 5-5H7z' fill='gray'/%3E%3C/svg%3E\");\n  text-overflow: ellipsis;\n  cursor: pointer;\n  box-sizing: border-box;\n  text-align: left;\n  outline: none;\n\n  line-height: 24px;\n  padding: 2px;\n  padding-left: 12px;\n  padding-right: 35px;\n  outline: none;\n  border-radius: 4px;\n}\n\n.jpicker-header:hover {\n  background-color: #eee;\n}\n\n.jpicker-content {\n  position: absolute;\n  top: 0;\n  display: none;\n  box-shadow: 0 4px 5px 0 rgba(0,0,0,0.14), 0 1px 10px 0 rgba(0,0,0,0.12), 0 2px 4px -1px rgba(0,0,0,0.2);\n  border-radius: 4px;\n  background-color: #fff;\n  padding: 4px;\n  z-index: 50;\n  text-align: left;\n  max-height: 200px;\n  scrollbar-width: thin;\n  scrollbar-color: #333 transparent;\n}\n\n.jpicker-content::-webkit-scrollbar {\n  width: 8px;\n}\n\n.jpicker-content::-webkit-scrollbar-track {\n  background: #eee;\n}\n\n.jpicker-content::-webkit-scrollbar-thumb {\n  background: #888;\n}\n\n.jpicker-content > div {\n  padding: 6px;\n  padding-left: 15px;\n  padding-right: 15px;\n}\n\n.jpicker-focus > .jpicker-content {\n  display: block;\n}\n\n.jpicker-content > div:hover {\n  background-color:#efefef;\n}\n\n.jpicker-content > div:empty {\n  opacity: 0;\n}\n\n.jpicker-header > i, .jpicker-header > div {\n  display: block;\n}\n\n.jpicker-focus > .jpicker-content.jpicker-columns {\n  display: flex !important ;\n  justify-content: center;\n  flex-wrap: wrap;\n}\n\n\n\n.jprogressbar\n{\n  cursor:pointer;\n  -webkit-touch-callout: none;\n  -webkit-user-select: none;\n  -khtml-user-select: none;\n  -moz-user-select: none;\n  -ms-user-select: none;\n  user-select: none;\n  box-sizing: border-box;\n  background:#fff;\n  -webkit-tap-highlight-color: transparent;\n  display: inline-block;\n  box-sizing: border-box;\n  cursor:pointer;\n  border:1px solid #ccc;\n  position:relative;\n}\n\n.jprogressbar::before {\n  content:attr(data-value);\n  position:absolute;\n  margin:5px;\n  margin-left:10px;\n}\n\n.jprogressbar-header::placeholder\n{\n  color:#000;\n}\n\n.jprogressbar::focus {\n  outline: auto 5px -webkit-focus-ring-color;\n}\n\n.jprogressbar > div {\n  background-color: #eee;\n  background-color: red;\n  box-sizing: border-box;\n  height:31px;\n}\n\n.jrating {\n  display:flex;\n}\n.jrating > div {\n  width:24px;\n  height:24px;\n  line-height:24px;\n  background-image: url(\"data:image/svg+xml,%0A%3Csvg xmlns='http://www.w3.org/2000/svg' width='24' height='24' viewBox='0 0 24 24'%3E%3Cpath d='M22 9.24l-7.19-.62L12 2 9.19 8.63 2 9.24l5.46 4.73L5.82 21 12 17.27 18.18 21l-1.63-7.03L22 9.24zM12 15.4l-3.76 2.27 1-4.28-3.32-2.88 4.38-.38L12 6.1l1.71 4.04 4.38.38-3.32 2.88 1 4.28L12 15.4z' fill='gray'/%3E%3Cpath d='M0 0h24v24H0z' fill='none'/%3E%3C/svg%3E\");\n}\n\n.jrating .jrating-over {\n  background-image: url(\"data:image/svg+xml,%0A%3Csvg xmlns='http://www.w3.org/2000/svg' width='24' height='24' viewBox='0 0 24 24' fill='black'%3E%3Cpath d='M0 0h24v24H0z' fill='none'/%3E%3Cpath d='M12 17.27L18.18 21l-1.64-7.03L22 9.24l-7.19-.61L12 2 9.19 8.63 2 9.24l5.46 4.73L5.82 21z'/%3E%3Cpath d='M0 0h24v24H0z' fill='none'/%3E%3C/svg%3E\");\n  opacity: 0.7;\n}\n\n.jrating .jrating-selected {\n  background-image: url(\"data:image/svg+xml,%0A%3Csvg xmlns='http://www.w3.org/2000/svg' width='24' height='24' viewBox='0 0 24 24' fill='red'%3E%3Cpath d='M0 0h24v24H0z' fill='none'/%3E%3Cpath d='M12 17.27L18.18 21l-1.64-7.03L22 9.24l-7.19-.61L12 2 9.19 8.63 2 9.24l5.46 4.73L5.82 21z'/%3E%3Cpath d='M0 0h24v24H0z' fill='none'/%3E%3C/svg%3E\");\n}\n\n\n.jsearch {\n  position: relative;\n  display: none;\n  -webkit-user-select: none;\n  -moz-user-select: none;\n  -ms-user-select: none;\n  user-select: none;\n}\n\n.jsearch_container {\n  position: absolute;\n  box-shadow: 0 1px 2px 0 rgba(60,64,67,0.302), 0 2px 6px 2px rgba(60,64,67,0.149);\n  border: none;\n  -webkit-border-radius: 4px;\n  border-radius: 4px;\n  width: 280px;\n  padding: 8px 0;\n\n  -webkit-box-shadow: 0 2px 4px rgba(0,0,0,0.2);\n  box-shadow: 0 2px 4px rgba(0,0,0,0.2);\n  -webkit-transition: opacity .218s;\n  transition: opacity .218s;\n  background: #fff;\n  border: 1px solid rgba(0,0,0,.2);\n  cursor: pointer;\n  margin: 0;\n  min-width: 300px;\n  outline: none;\n  width: auto;\n  -webkit-user-select: none;\n  -moz-user-select: none;\n  -ms-user-select: none;\n  user-select: none;\n}\n\n.jsearch_container:empty:after {\n  content: attr(data-placeholder);\n}\n\n.jsearch_container > div {\n  color: #333;\n  cursor: pointer;\n  display: -webkit-box;\n  display: -webkit-flex;\n  display: flex;\n  padding: 5px 10px;\n  user-select: none;\n  -webkit-align-items: center;\n  align-items: center;\n\n  -webkit-user-select: none;\n  -moz-user-select: none;\n  -ms-user-select: none;\n  user-select: none;\n}\n\n.jsearch_container > div:hover {\n  background-color: #e8eaed;\n}\n\n.jsearch_container > div > img {\n  width: 32px;\n  height: 32px;\n  user-select: none;\n  border-radius: 16px;\n  margin-right: 2px;\n}\n\n.jsearch_container > div > div {\n  overflow: hidden;\n  text-overflow: ellipsis;\n  margin-left: 2px;\n  max-width: 300px;\n  white-space: nowrap;\n  user-select: none;\n}\n\n.jsearch_container .selected {\n  background-color: #e8eaed;\n}\n\n.jslider {\n  outline: none;\n}\n\n.jslider-focus {\n  width: 100% !important;\n  height: 100% !important;\n}\n\n.jslider-focus img {\n  display: none;\n}\n\n.jslider img {\n  width: 100px;\n}\n\n.jslider-left::before {\n  position: fixed;\n  left: 15px;\n  top: 50%;\n  content:'arrow_back_ios';\n  color: #fff;\n  width: 30px;\n  height: 30px;\n  font-family: 'Material Icons';\n  font-size: 30px;\n  /* before it was 0px 0px 0px #000 */\n  text-shadow: 0px 0px 6px rgb(56,56,56);\n  text-align: center;\n  cursor: pointer;\n}\n\n.jslider-right::after {\n  position: fixed;\n  right: 15px;\n  top: 50%;\n  content: 'arrow_forward_ios';\n  color: #fff;\n  width: 30px;\n  height: 30px;\n  font-family: 'Material Icons';\n  font-size: 30px;\n  /* before it was 0px 0px 0px #000 */\n  text-shadow: 0px 0px 6px rgb(56,56,56);\n  text-align: center;\n  cursor: pointer;\n}\n\n.jslider-close {\n  width:24px;\n  height:24px;\n  background-image: url(\"data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='24' height='24' viewBox='0 0 24 24' fill='white'%3E%3Cpath d='M19 6.41L17.59 5 12 10.59 6.41 5 5 6.41 10.59 12 5 17.59 6.41 19 12 13.41 17.59 19 19 17.59 13.41 12z'/%3E%3Cpath d='M0 0h24v24H0z' fill='none'/%3E%3C/svg%3E\");\n  position:fixed;\n  top:15px;\n  right:15px;\n  cursor:pointer;\n  z-index:3000;\n\n  display: block !important;\n}\n\n.jslider-counter {\n  height:24px;\n  background-color: transparent;\n  position:fixed;\n  left: 50%;\n  transform: translateX(-50%);\n  bottom: 15px;\n  cursor:pointer;\n  z-index:3000;\n\n  display: flex;\n  display: -webkit-flex;\n  -webkit-justify-content: center;\n  -webkit-align-items: center;\n  -webkit-flex-direction: row;\n  justify-content: center;\n  align-items: center;\n  flex-direction: row;\n}\n\n.jslider-caption {\n  position: fixed;\n  max-width: 90vw;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n  overflow: hidden;\n  top:15px;\n  left: 15px;\n  z-index:3000;\n  color: #FFF;\n  font-size: 1rem;\n\n  display: block !important;\n}\n\n.jslider-counter div {\n  width: 10px;\n  height: 10px;\n  background: #fff;\n  border-radius: 50%;\n  margin: 0px 5px;\n\n  display: block !important;\n}\n\n.jslider-counter .jslider-counter-focus {\n  background-color: cornflowerblue;\n  pointer-events: none;\n}\n\n.jslider-focus {\n  position:fixed;\n  left:0;\n  top:0;\n  width: 100%;\n  min-height:100%;\n  max-height:100%;\n  z-index:2000;\n  margin:0px;\n  box-sizing:border-box;\n\n  background-color:rgba(0,0,0,0.8);\n  -webkit-transition-duration: .05s;\n  transition-duration: .05s;\n  display: flex;\n  -ms-flex-align: center;\n  -webkit-align-items: center;\n  -webkit-box-align: center;\n\n  align-items: center;\n}\n\n.jslider-focus img {\n  width: 50vw;\n  height: auto;\n  box-sizing: border-box;\n  margin:0 auto;\n  vertical-align:middle;\n  display:none;\n}\n\n.jslider-focus img.jslider-vertical {\n  width: auto;\n  /* before it was 50vh */\n  height: 80vh;\n}\n\n@media only screen and (max-width: 576px) {\n  .jslider-focus img.jslider-vertical {\n      width: 99vw !important;\n      height: auto !important;\n  }\n\n  .jslider-focus img {\n      width: 100vw !important;\n      height: auto !important;\n  }\n}\n\n.jslider-grid {\n  display: -ms-grid;\n  display: grid;\n  grid-gap: 1px;\n  position: relative;\n}\n\n.jslider-grid[data-number='2'] {\n  -ms-grid-columns: 1fr 50%;\n  grid-template-columns: 1fr 50%;\n}\n\n.jslider-grid[data-number='3'] {\n  -ms-grid-columns: 1fr 33%;\n  grid-template-columns: 1fr 33%;\n}\n\n.jslider-grid[data-number='4'] {\n  -ms-grid-columns: 1fr 25%;\n  grid-template-columns: 1fr 25%;\n}\n\n.jslider-grid img {\n  display: none;\n  width: 100%;\n  height: 100%;\n  object-fit: cover;\n}\n\n.jslider-grid[data-total]:after {\n  content: attr(data-total) \"+\";\n  font-size: 1.5em;\n  position:absolute;\n  color: #fff;\n  right: 15px;\n  bottom: 6px;\n}\n\n.jslider-grid img:first-child {\n  -ms-grid-column: 1;\n  -ms-grid-row: 1;\n  grid-column: 1;\n  grid-row: 1;\n  display: block;\n}\n\n.jslider-grid[data-number='2'] img:nth-child(2) {\n  -ms-grid-column: 2;\n  -ms-grid-row: 1;\n  grid-column: 2;\n  grid-row: 1;\n  display: block;\n}\n\n.jslider-grid[data-number='3'] img:first-child {\n  -ms-grid-column: 1 / 2;\n  -ms-grid-row: 1 / 4;\n  grid-column: 1 / 2;\n  grid-row: 1 / 4;\n}\n\n.jslider-grid[data-number='3'] img:nth-child(2) {\n  -ms-grid-column: 2;\n  -ms-grid-row: 1;\n  grid-column: 2;\n  grid-row: 1;\n  display: block;\n}\n\n.jslider-grid[data-number='3'] img:nth-child(3) {\n  -ms-grid-column: 2;\n  -ms-grid-row: 2;\n  grid-column: 2;\n  grid-row: 2;\n  display: block;\n}\n\n.jslider-grid[data-number='4'] img:first-child {\n  -ms-grid-column: 1 / 2;\n  -ms-grid-row: 1 / 4;\n  grid-column: 1 / 2;\n  grid-row: 1 / 4;\n}\n\n.jslider-grid[data-number='4'] img:nth-child(2) {\n  -ms-grid-column: 2;\n  -ms-grid-row: 1;\n  grid-column: 2;\n  grid-row: 1;\n  display: block;\n}\n\n.jslider-grid[data-number='4'] img:nth-child(3) {\n  -ms-grid-column: 2;\n  -ms-grid-row: 2;\n  grid-column: 2;\n  grid-row: 2;\n  display: block;\n}\n\n.jslider-grid[data-number='4'] img:nth-child(4) {\n  -ms-grid-column: 2;\n  -ms-grid-row: 3;\n  grid-column: 2;\n  grid-row: 3;\n  display: block;\n}\n\n\n.jtabs {\n  max-width: 100vw;\n  position: relative;\n}\n\n.jtabs .jtabs-headers-container {\n  display: flex;\n  align-items: center;\n}\n\n.jtabs .jtabs-headers {\n  display: flex;\n  align-items: center;\n  overflow: hidden;\n  position: relative;\n}\n\n\n.jtabs {\n  max-width: 100vw;\n  position: relative;\n}\n\n.jtabs .jtabs-headers-container {\n  display: flex;\n  align-items: center;\n}\n\n.jtabs .jtabs-headers {\n  display: flex;\n  align-items: center;\n  overflow: hidden;\n  position: relative;\n}\n\n.jtabs .jtabs-headers > div:not(.jtabs-border) {\n  padding: 6px;\n  padding-left: 20px;\n  padding-right: 20px;\n  margin-left: 1px;\n  margin-right: 1px;\n  background-color: #f1f1f1;\n  cursor: pointer;\n  white-space: nowrap;\n  text-align: center;\n}\n\n.jtabs .jtabs-headers > div.jtabs-selected {\n  background-color: #e8e8e8;\n  color: #000;\n}\n\n.jtabs .jtabs-headers > div > div {\n  color: #555;\n  width: 100%;\n  overflow: hidden;\n}\n\n.jtabs .jtabs-headers i {\n  display: block;\n  margin: auto;\n}\n\n.jtabs .jtabs-content {\n  box-sizing: border-box;\n}\n\n.jtabs .jtabs-content > div {\n  display: none;\n  box-sizing: border-box;\n}\n\n.jtabs .jtabs-content > div.jtabs-selected {\n  display: block;\n}\n\n.jtabs .jtabs-border {\n  position: absolute;\n  height: 2px;\n  background-color: #888;\n  transform-origin: left;\n  transition: all .2s cubic-bezier(0.4,0,0.2,1);\n  transition-property: color,left,transform;\n  display: none;\n}\n\n.jtabs-animation .jtabs-border {\n  display: initial;\n}\n\n.jtabs .jtabs-controls {\n  margin: 3px;\n  margin-left: 10px;\n  display: flex;\n  min-width: 82px;\n}\n\n.jtabs .jtabs-controls > div {\n  cursor: pointer;\n  background-position: center;\n  background-repeat: no-repeat;\n  width: 24px;\n  height: 24px;\n  line-height: 24px;\n}\n\n.jtabs .jtabs-prev {\n  margin-left: 10px;\n  background-image: url(\"data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 24 24' fill='gray' width='18px' height='18px'%3E%3Cpath d='M0 0h24v24H0z' fill='none'/%3E%3Cpath d='M15.41 7.41L14 6l-6 6 6 6 1.41-1.41L10.83 12z'/%3E%3C/svg%3E\");\n}\n\n.jtabs .jtabs-prev.disabled {\n  margin-left: 10px;\n  background-image: url(\"data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 24 24' fill='lightgray' width='18px' height='18px'%3E%3Cpath d='M0 0h24v24H0z' fill='none'/%3E%3Cpath d='M15.41 7.41L14 6l-6 6 6 6 1.41-1.41L10.83 12z'/%3E%3C/svg%3E\");\n}\n\n.jtabs .jtabs-next {\n  background-image: url(\"data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 24 24' fill='gray' width='18px' height='18px'%3E%3Cpath d='M0 0h24v24H0z' fill='none'/%3E%3Cpath d='M10 6L8.59 7.41 13.17 12l-4.58 4.59L10 18l6-6z'/%3E%3C/svg%3E\");\n}\n\n.jtabs .jtabs-next.disabled {\n  background-image: url(\"data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 24 24' fill='lightgray' width='18px' height='18px'%3E%3Cpath d='M0 0h24v24H0z' fill='none'/%3E%3Cpath d='M10 6L8.59 7.41 13.17 12l-4.58 4.59L10 18l6-6z'/%3E%3C/svg%3E\");\n}\n\n.jtabs .jtabs-add {\n  background-image: url(\"data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' height='24' viewBox='0 0 24 24' width='24'%3E%3Cpath d='M19 3H5c-1.11 0-2 .9-2 2v14c0 1.1.89 2 2 2h14c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2zm-2 10h-4v4h-2v-4H7v-2h4V7h2v4h4v2z' fill='%23bbbbbb'/%3E%3Cpath d='M0 0h24v24H0z' fill='none'/%3E%3C/svg%3E\");\n}\n\n/** Modern skin **/\n\n.jtabs.jtabs-modern .jtabs-headers > div:not(.jtabs-border) {\n  padding: 4px;\n  padding-left: 10px;\n  padding-right: 10px;\n  background-color: #fff;\n}\n\n.jtabs.jtabs-modern .jtabs-headers > .jtabs-selected  {\n  color: #000;\n}\n\n.jtabs.jtabs-modern .jtabs-headers > .jtabs-selected .material-icons {\n  color: #000;\n}\n\n.jtabs.jtabs-modern .jtabs-headers {\n  background: #EEEEEF !important;\n  padding: 2px;\n  border-radius: 4px;\n}\n\n.jtabs.jtabs-modern .jtabs-headers .jtabs-border {\n  border-color: #EEEEEF !important;\n}\n\n.jtabs.jtabs-modern .jtabs-border {\n  background-color: rgba(194, 197, 188, 0.884);\n}\n\n.jtags {\n  display: flex;\n  flex-wrap: wrap;\n  -ms-flex-direction: row;\n  -webkit-flex-direction: row;\n  flex-direction: row;\n  -ms-flex-pack: flex-start;\n  -webkit-justify-content: space-between;\n  justify-content: flex-start;\n  padding: 2px;\n  border: 1px solid #ccc;\n}\n\n.jtags.jtags-empty:not(.jtags-focus)::before {\n  position: absolute;\n  margin: 5px;\n  color: #ccc;\n  content:attr(data-placeholder);\n}\n\n.jtags > div {\n  padding: 3px;\n  padding-left: 10px;\n  padding-right: 22px;\n  position: relative;\n  border-radius: 1px;\n  margin: 2px;\n  display: block;\n  outline: none;\n}\n\n.jtags > div:empty:before {\n  content: \" \";\n  white-space: pre;\n}\n\n.jtags > div::after {\n  content: 'x';\n  position: absolute;\n  top: 4px;\n  right: 4px;\n  width: 12px;\n  height: 12px;\n  cursor: pointer;\n  font-size: 11px;\n  display: none;\n}\n\n.jtags_label {\n  background-color: #eeeeee !important;\n}\n\n.jtags_label::after {\n  display: inline-block !important;\n}\n\n.jtags_error::after {\n  color: #fff  !important;\n}\n\n.jtags_error {\n  background-color: #d93025 !important;\n  color: #fff;\n}\n\n\n.jtoolbar-container {\n  border-radius: 2px;\n  margin-bottom: 5px;\n  box-shadow: 0 4px 5px 0 rgba(0,0,0,0.14), 0 1px 10px 0 rgba(0,0,0,0.12), 0 2px 4px -1px rgba(0,0,0,0.2);\n  display: inline-flex !important;\n}\n\n.jtoolbar {\n  cursor: pointer;\n  white-space: nowrap;\n  display: flex;\n  padding:4px;\n  -webkit-user-select: none;\n  -moz-user-select: none;\n  -ms-user-select: none;\n  user-select: none;\n  font-size: 13px;\n}\n\n.jtoolbar-mobile {\n  display: flex;\n  position:fixed;\n  bottom: 0;\n  margin: 0;\n  left: 0;\n  width: 100%;\n  background: #f7f7f8;\n  z-index: 1;\n  box-sizing: border-box;\n  box-shadow: 0 -1px 2px rgba(0,0,0,.1);\n  border-radius: 0px;\n}\n\n.jtoolbar > div {\n  display: inline-flex;\n  align-items: center;\n  box-sizing: border-box;\n  vertical-align:middle;\n  justify-content: space-evenly;\n}\n\n.jtoolbar-mobile > div {\n  display: flex;\n  width: 100%;\n}\n\n.jtoolbar .jtoolbar-item {\n  text-align: center;\n  margin: auto;\n  padding: 2px;\n  padding-left:4px;\n  padding-right:4px;\n}\n\n.jtoolbar-mobile .jtoolbar-item {\n  position: relative;\n  flex:1;\n}\n\n.jtoolbar .jtoolbar-divisor {\n  width: 2px;\n  height: 18px;\n  padding: 0px;\n  margin-left: 4px;\n  margin-right: 4px;\n  background-color: #ddd;\n}\n\n.jtoolbar .jtoolbar-label {\n  padding-left: 8px;\n  padding-right: 8px;\n}\n\n\n\n.jtoolbar-mobile a\n{\n  text-decoration:none;\n  display:inline-block;\n}\n\n.jtoolbar-mobile i {\n  display: inline-flex !important;\n  color:#929292;\n}\n\n.jtoolbar-mobile span {\n  font-size:0.7em;\n  display:block;\n  color:#929292;\n}\n\n.jtoolbar-mobile .jtoolbar-selected a, .jtoolbar-mobile .jtoolbar-selected i, .jtoolbar-mobile .jtoolbar-selected span {\n  color:var(--active-color) !important;\n  background-color:transparent;\n}\n\n.jtoolbar-item {\n  -webkit-user-select: none;\n  -moz-user-select: none;\n  -ms-user-select: none;\n  user-select: none;\n}\n\n.jtoolbar-item i {\n  display: block;\n  color:#333;\n}\n\n.jtoolbar-item:hover {\n  background-color:#f2f2f2;\n}\n\n\n.jtoolbar .jpicker {\n  padding-left:0px;\n  padding-right:0px;\n}\n\n.jtoolbar .jpicker-header {\n  height: 24px;\n  line-height: 24px;\n  padding: 0px;\n  padding-right: 20px;\n  padding-left: 8px;\n  background-position: top 50% right 0px;\n  display: flex;\n  align-items: center;\n}\n\n.jtoolbar .jpicker-content > div {\n  padding: 6px;\n}\n\n.jtoolbar-active {\n  background-color:#eee;\n}\n\n.jtoolbar .fa {\n  width: 18px;\n  height: 18px;\n  display: block;\n  line-height: 18px;\n  font-size: 14px;\n}\n\n.jtoolbar .material-icons {\n  font-size: 18px;\n  width: 24px;\n  height: 24px;\n  display: block;\n  line-height: 24px;\n  transform: rotate(0.03deg);\n  text-align: center;\n}\n\n.jtoolbar .jtoolbar-arrow {\n  background-repeat: no-repeat;\n  background-position: center;\n  background-image: url(\"data:image/svg+xml,%0A%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 24 24' fill='black' width='18px' height='18px'%3E%3Cpath d='M0 0h24v24H0z' fill='none'/%3E%3Cpath d='M12 8c1.1 0 2-.9 2-2s-.9-2-2-2-2 .9-2 2 .9 2 2 2zm0 2c-1.1 0-2 .9-2 2s.9 2 2 2 2-.9 2-2-.9-2-2-2zm0 6c-1.1 0-2 .9-2 2s.9 2 2 2 2-.9 2-2-.9-2-2-2z'/%3E%3C/svg%3E\");\n  width: 24px;\n  height: 16px;\n  margin-left: 4px;\n  border-left: 1px solid #f2f2f2;\n}\n\n.jtoolbar-floating {\n  position: absolute;\n  display: none;\n  box-shadow: 0 4px 5px 0 rgba(0,0,0,0.14), 0 1px 10px 0 rgba(0,0,0,0.12), 0 2px 4px -1px rgba(0,0,0,0.2);\n  border-radius: 4px;\n  background-color: #fff;\n  padding: 4px;\n  z-index: 50;\n  text-align: left;\n}\n\n.jtoolbar-floating .jtoolbar-divisor {\n  display: none;\n}\n\n.jtoolbar-arrow-selected .jtoolbar-floating {\n  display: flex;\n  flex-wrap: wrap;\n}\n\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
